import css from 'styled-jsx/css';

const styles = css`.beacon-container {
    --black: #000000;
    --dark-gray: #b3b3b3;
    --error: red;
    --green: green;
    --gray-1: #787778;
    --gray-1-5: #767676;
    --gray-2: #bbbbbb;
    --gray-2-5: #d8d8d8;
    --gray-3: #eeeeee;
    --gray-4: #f8f8f8;
    --gray-5: #fafafa;
    --gray-6: #ebebeb;
    --gray-footer: #4f4f4f;
    --gray-footer-text: #757575;
    --gray-black: #111111;
    --heading-gray: #505050;

    --mmr-yellow: #f8e71c;
    --mmr-red: #b41f00;
    --module-gray: #f7f7f7;
    --module-white: #ffffff;
    --primary-bg: #eeeeee;

    --risk-high: #e37a00;
    --risk-low: #7c993f;
    --risk-med: #ffcc00;
    --text-fg: #3b3b3b;
    --text-header: #4c5a6a;
    --tooltip-header: #4c5a69;
    --warm-grey: #898989;
    --white: #ffffff;
    --border-line: #b8b8b8;
    --orange-button: #e17a17;

    --text-dark: #3b3b3b;
    --text-med: #4f4f4f;
    --text-light: #898989;
    --text-xlight: #c4c4c4;
    --text-disabled: #b1b1b1;

    --subtle-blue-gray: #f7f9fa;
    --beacon-dark-blue: #004b71;
    --beacon-light-blue: #00c3e0;
    --beacon-bright-blue: #05c3de;
    --beacon-shadow-blue: #ace3ea;
    --primary-blue: #2998cc;
    --ice-blue: #24c0d8;
    --bright-blue: #086ea1;
    --row-blue: #06c3df;
    --dark-blue: #054c70;
    --dark-blue-2: #043954;
    --navy-blue: #0a4c71;

    --navy-gradient: linear-gradient(115deg, #054c70, #086ea1);

    /* New design variables introduced 11-12-2019 */
    --background-grey: #e5e5e5;
    --grey-200: #f0f3f5;
    --grey-300: #b4babf;
    --grey-400: #959fa6;
    --grey-500: #879199;
    --grey-600: #6b7880;
    --grey-700: #56646b;
    --grey-800: #475359;

    --error-red: #dd3636;
    --success-green: #008a00;
    --interactive-blue: #006894;

    /* New design variables introduced 7-16-2020 */
    --border-white: #D3D7DA;
    --label-grey: #3B4B59;

    @lost gutter 24px;
    --page-max-width: 1230px;
    --page-padding: 32px;
    --module-gutter: 24px;
    --half-gutter: calc(var(--module-gutter) / 2);
    --quarter-gutter: calc(var(--half-gutter) / 2);
    --module-padding: 24px;
    --mobile-padding: 4px;

    /* Margin and padding should be in multiples of 8 (i.e.---8, 16, 24) */
    --element-spacing-1: 8px;
    --element-spacing-2: calc(var(--element-spacing-1) * 2);
    --element-spacing-3: calc(var(--element-spacing-1) * 3);
    --element-spacing-4: calc(var(--element-spacing-1) * 4);

    --border-thin-width: 1px;
    --border-width: 2px;
    --border-radius: 5px;

    --xxxxsmall-font: 5px;
    --xxxsmall-font: 10px;
    --xxsmall-font: 12px;
    --xsmall-font: 14px;
    --small-font: 16px;
    --med-font: 18px;
    --large-font: 20px;
    --xlarge-font: 24px;
    --xxlarge-font: 36px;
    --xxxlarge-font: 48px;
    --title-font: 18px;
    --label-sup-font: 100%;
    --title-large-font:80px;
    --xxxxlarge-font: 100px;
    --xxxxxlarge-font: 150px;

    --h1-font: 36px;
    --h2-font: 20px;
    --p1: 16px;
    --p2: 14px;
    --caption-size: 12px;

    --h1-font-mobile: 24px;
    --h2-font-mobile: 18px;
    --p1-mobile: 16px;
    --p2-mobile: 14px;
    --caption-size-mobile: 12px;

    --sans-serif-font: 'Nimbus Sans', sans-serif;
    --condensed-font: 'Nimbus Sans Condensed', 'Nimbus Sans Light', sans-serif;
    --condensed-bold: 'Nimbus Sans Condensed Bold', 'Nimbus Sans Condensed',
        sans-serif;
    --serif-font: 'IBM Plex Serif', serif;
    --mono-font: 'Nimbus Sans', sans-serif;
    --nimbus-reg: 'Nimbus Sans Reg', sans-serif;
    --nimbus-italic: 'Nimbus Sans Italic', sans-serif;
    --nimbus-bold: 'Nimbus Sans Bold', sans-serif;
    --nimbus-light: 'Nimbus Sans Light', sans-serif;
    --nimbus-black: 'Nimbus Sans Black', sans-serif;

    --regular-weight: 400;
    --bold-weight: 700;
    --light-weight: 100;
    --normal-weight: normal;

    /* New II Design Pattern - Introduced 11-12-2019 */
    --nimbus-normal: 'Nimbus Sans', normal;

    --line-height-xs: 18px;
    --line-height-sm: 22px;
    --line-height-md: 24px;
    --line-height-lg: 26px;

}
/**
 * Do not edit directly
 * Generated on Tue, 08 Mar 2022 05:07:16 GMT
 */
.beacon-container {
  --beacon-border-widths-hairline: 1px;
  --beacon-colors-bright-blue: rgba(5, 195, 222, 1);
  --beacon-colors-blue-gradient: linear-gradient(180deg, rgba(5, 76, 112, 1) 0%, rgba(0, 47, 72, 1) 83%, rgba(0, 47, 72, 1) 100%);
  --beacon-colors-gray-gradient: linear-gradient(180deg, rgba(59, 75, 89, 1) 0%, rgba(30, 45, 57, 1) 92%, rgba(30, 45, 57, 1) 100%);
  --beacon-colors-dark-blue: rgba(5, 76, 112, 1);
  --beacon-colors-midnight-blue: rgba(0, 47, 72, 1);
  --beacon-colors-light-green: rgba(36, 134, 71, 1);
  --beacon-colors-medium-green: rgba(31, 117, 62, 1);
  --beacon-colors-dark-green: rgba(27, 100, 53, 1);
  --beacon-colors-light-red: rgba(221, 54, 54, 1);
  --beacon-colors-medium-red: rgba(218, 37, 37, 1);
  --beacon-colors-dark-red: rgba(201, 34, 34, 1);
  --beacon-colors-light-blue-1: rgba(8, 110, 161, 1);
  --beacon-colors-medium-blue-1: rgba(7, 96, 141, 1);
  --beacon-colors-dark-blue-1: rgba(6, 83, 121, 1);
  --beacon-colors-light-blue-2: rgba(0, 125, 179, 1);
  --beacon-colors-medium-blue-2: rgba(0, 110, 158, 1);
  --beacon-colors-dark-blue-2: rgba(0, 96, 138, 1);
  --beacon-colors-opaque-blue-1: rgba(8, 110, 161, 0.08);
  --beacon-colors-opaque-blue-2: rgba(8, 110, 161, 0.12);
  --beacon-colors-white: rgba(255, 255, 255, 1);
  --beacon-colors-opaque-white-1: rgba(255, 255, 255, 0.12);
  --beacon-colors-opaque-white-2: rgba(255, 255, 255, 0.08);
  --beacon-colors-dark-grey-1: rgba(30, 45, 57, 1);
  --beacon-colors-dark-grey-2: rgba(37, 55, 70, 1);
  --beacon-colors-dark-grey-3: rgba(59, 75, 89, 1);
  --beacon-colors-dark-grey-4: rgba(81, 95, 107, 1);
  --beacon-colors-medium-grey-1: rgba(102, 115, 126, 1);
  --beacon-colors-medium-grey-2: rgba(124, 135, 144, 1);
  --beacon-colors-medium-grey-3: rgba(146, 155, 163, 1);
  --beacon-colors-medium-grey-4: rgba(168, 175, 181, 1);
  --beacon-colors-light-grey-1: rgba(190, 195, 200, 1);
  --beacon-colors-light-grey-2: rgba(211, 215, 218, 1);
  --beacon-colors-light-grey-3: rgba(233, 235, 237, 1);
  --beacon-colors-light-grey-4: rgba(244, 245, 246, 1);
  --beacon-colors-light-grey-5: rgba(249, 250, 250, 1);
  --beacon-duration-tenth-second: .1s;
  --beacon-duration-eighth-second: .125s;
  --beacon-duration-quarter-second: .25s;
  --beacon-duration-half-second: .5s;
  --beacon-duration-full-second: 1s;
  --beacon-duration-interaction-transition: .25s;
  --beacon-opacity-8: 0.08;
  --beacon-opacity-10: 0.1;
  --beacon-opacity-12: 0.12;
  --beacon-opacity-20: 0.2;
  --beacon-opacity-30: 0.3;
  --beacon-opacity-40: 0.4;
  --beacon-opacity-50: 0.5;
  --beacon-opacity-60: 0.6;
  --beacon-opacity-70: 0.7;
  --beacon-opacity-80: 0.8;
  --beacon-opacity-90: 0.9;
  --beacon-opacity-100: 1;
  --beacon-size-8: 8px;
  --beacon-size-10: 10px;
  --beacon-size-12: 12px;
  --beacon-size-14: 14px;
  --beacon-size-16: 16px;
  --beacon-size-18: 18px;
  --beacon-size-20: 20px;
  --beacon-size-24: 24px;
  --beacon-size-28: 28px;
  --beacon-size-32: 32px;
  --beacon-size-36: 36px;
  --beacon-size-40: 40px;
  --beacon-size-48: 48px;
  --beacon-size-56: 56px;
  --beacon-size-64: 64px;
  --beacon-size-72: 72px;
  --beacon-spacing-spacer-2: 0.125rem;
  --beacon-transition-timing-function-ease: ease;
  --beacon-transition-timing-function-ease-in: ease-in;
  --beacon-transition-timing-function-ease-out: ease-out;
  --beacon-transition-timing-function-linear: linear;
  --beacon-font-families-m-ying-hei: M Ying Hei HK;
  --beacon-font-families-tazugane: Tazugane Gothic StdN;
  --beacon-font-families-nimbus-sans-novus: Nimbus Sans Novus;
  --beacon-font-family-fallback: Helvetica, Arial, sans-serif;
  --beacon-font-family-nimbus-regular: Nimbus Sans Novus Regular;
  --beacon-font-family-nimbus-italic: Nimbus Sans Novus Italic;
  --beacon-font-family-nimbus-bold: Nimbus Sans Novus Bold;
  --beacon-font-family-nimbus-bold-italic: Nimbus Sans Novus Bold Italic;
  --beacon-font-family-small: Nimbus Sans Novus Regular, Helvetica, Arial, sans-serif;
  --beacon-font-family-bold: Nimbus Sans Novus Bold, Helvetica, Arial, sans-serif;
  --beacon-font-family-bold-italic: Nimbus Sans Novus Bold Italic, Helvetica, Arial, sans-serif;
  --beacon-font-family-italic: Nimbus Sans Novus Italic, Helvetica, Arial, sans-serif;
  --beacon-font-family-regular: Nimbus Sans Novus Regular, Helvetica, Arial, sans-serif;
  --beacon-font-sizes-s-10: 0.625rem;
  --beacon-font-sizes-s-20: 0.75rem;
  --beacon-font-sizes-s-30: 0.875rem;
  --beacon-font-sizes-s-40: 1rem;
  --beacon-font-sizes-s-50: 1.125rem;
  --beacon-font-sizes-m-10: 1.25rem;
  --beacon-font-sizes-m-20: 1.5rem;
  --beacon-font-sizes-m-30: 1.75rem;
  --beacon-font-sizes-m-40: 2rem;
  --beacon-font-sizes-m-50: 2.25rem;
  --beacon-font-sizes-l-10: 2.5rem;
  --beacon-font-sizes-l-20: 3rem;
  --beacon-font-sizes-l-30: 3.5rem;
  --beacon-font-sizes-l-40: 4rem;
  --beacon-font-sizes-l-50: 4.5rem;
  --beacon-font-weights-m-ying-hei: 400;
  --beacon-font-weights-tazugane: 300;
  --beacon-font-weights-bold: 700;
  --beacon-font-weights-regular: 400;
  --beacon-letter-spacings-nimbus-sans-novus: 0.0012em;
  --beacon-letter-spacings-tazugane: 0.0012em;
  --beacon-letter-spacings-m-ying-hei: 0.08em;
  --beacon-line-heights-module-cjk-s-10: 1.60;
  --beacon-line-heights-module-cjk-s-20: 1.33;
  --beacon-line-heights-module-cjk-s-30: 1.71;
  --beacon-line-heights-module-cjk-s-40: 1.75;
  --beacon-line-heights-module-cjk-s-50: 1.56;
  --beacon-line-heights-module-cjk-m-10: 1.40;
  --beacon-line-heights-module-cjk-m-20: 1.67;
  --beacon-line-heights-module-cjk-m-30: 1.43;
  --beacon-line-heights-module-cjk-m-40: 1.38;
  --beacon-line-heights-module-cjk-m-50: 1.33;
  --beacon-line-heights-module-cjk-l-10: 1.40;
  --beacon-line-heights-module-cjk-l-20: 1.42;
  --beacon-line-heights-module-cjk-l-30: 1.43;
  --beacon-line-heights-module-cjk-l-40: 1.50;
  --beacon-line-heights-module-cjk-l-50: 1.44;
  --beacon-line-heights-long-form-cjk-s-10: 1.60;
  --beacon-line-heights-long-form-cjk-s-20: 1.33;
  --beacon-line-heights-long-form-cjk-s-30: 1.71;
  --beacon-line-heights-long-form-cjk-s-40: 1.75;
  --beacon-line-heights-long-form-cjk-s-50: 1.78;
  --beacon-line-heights-long-form-cjk-m-10: 1.60;
  --beacon-line-heights-long-form-cjk-m-20: 1.67;
  --beacon-line-heights-long-form-cjk-m-30: 1.57;
  --beacon-line-heights-long-form-cjk-m-40: 1.50;
  --beacon-line-heights-long-form-cjk-m-50: 1.44;
  --beacon-line-heights-long-form-cjk-l-10: 1.40;
  --beacon-line-heights-long-form-cjk-l-20: 1.42;
  --beacon-line-heights-long-form-cjk-l-30: 1.43;
  --beacon-line-heights-long-form-cjk-l-40: 1.50;
  --beacon-line-heights-long-form-cjk-l-50: 1.44;
  --beacon-line-heights-module-latin-s-10: 1.60;
  --beacon-line-heights-module-latin-s-20: 1.33;
  --beacon-line-heights-module-latin-s-30: 1.43;
  --beacon-line-heights-module-latin-s-40: 1.50;
  --beacon-line-heights-module-latin-s-50: 1.33;
  --beacon-line-heights-module-latin-m-10: 1.40;
  --beacon-line-heights-module-latin-m-20: 1.33;
  --beacon-line-heights-module-latin-m-30: 1.29;
  --beacon-line-heights-module-latin-m-40: 1.25;
  --beacon-line-heights-module-latin-m-50: 1.22;
  --beacon-line-heights-module-latin-l-10: 1.20;
  --beacon-line-heights-module-latin-l-20: 1.17;
  --beacon-line-heights-module-latin-l-30: 1.14;
  --beacon-line-heights-module-latin-l-40: 1.13;
  --beacon-line-heights-module-latin-l-50: 1.11;
  --beacon-line-heights-long-form-latin-s-10: 1.60;
  --beacon-line-heights-long-form-latin-s-20: 1.33;
  --beacon-line-heights-long-form-latin-s-30: 1.43;
  --beacon-line-heights-long-form-latin-s-40: 1.50;
  --beacon-line-heights-long-form-latin-s-50: 1.56;
  --beacon-line-heights-long-form-latin-m-10: 1.60;
  --beacon-line-heights-long-form-latin-m-20: 1.33;
  --beacon-line-heights-long-form-latin-m-30: 1.43;
  --beacon-line-heights-long-form-latin-m-40: 1.38;
  --beacon-line-heights-long-form-latin-m-50: 1.33;
  --beacon-line-heights-long-form-latin-l-10: 1.20;
  --beacon-line-heights-long-form-latin-l-20: 1.17;
  --beacon-line-heights-long-form-latin-l-30: 1.14;
  --beacon-line-heights-long-form-latin-l-40: 1.13;
  --beacon-line-heights-long-form-latin-l-50: 1.11;
  --beacon-radii-circle: 100px;
  --beacon-radii-rounded: 4px;
  --beacon-radii-hard: 0px;
  --beacon-shadows-elevation-b-0-dt: 0px 1px 0px rgba(0, 47, 72, 0.4);
  --beacon-shadows-elevation-t-0-dt: 0px -1px 0px rgba(0, 47, 72, 0.4);
  --beacon-shadows-elevation-3-dt: 0px 0px 24px rgba(0, 47, 72, 0.56);
  --beacon-shadows-elevation-2-dt: 0px 0px 12px rgba(0, 47, 72, 0.64);
  --beacon-shadows-elevation-b-0-lt: 0px -1px 0px rgba(146, 155, 163, 0.4);
  --beacon-shadows-elevation-t-0-lt: 0px -1px 0px rgba(146, 155, 163, 0.4);
  --beacon-shadows-elevation-3-lt: 0px 0px 24px rgba(146, 155, 163, 0.48);
  --beacon-shadows-elevation-2-lt: 0px 0px 12px rgba(146, 155, 163, 0.64);
  --beacon-shadows-elevation-1-lt: 0px 0px 4px rgba(146, 155, 163, 0.8);
  --beacon-shadows-elevation-1-dt: 0px 0px 4px rgba(0, 47, 72, 0.8);
  --beacon-accordion-expanded-icon-color: #086ea1;
  --beacon-accordion-expanded-icon-font-size: 1rem;
  --beacon-accordion-expanded-icon-font-weight: bold;
  --beacon-accordion-expanded-icon-space-margin: calc(16px - 1px);
  --beacon-accordion-label-color-background: #ffffff;
  --beacon-accordion-label-color-border: #e9ebed;
  --beacon-accordion-label-color-text-primary-default: #086ea1;
  --beacon-accordion-label-color-text-primary-active: #3b4b59;
  --beacon-accordion-label-color-text-secondary-default: #1e2d39;
  --beacon-accordion-label-font-family: Nimbus Sans Novus Bold, Helvetica, Arial, sans-serif;
  --beacon-accordion-label-font-line-height-breakpoint-default: 1.33;
  --beacon-accordion-label-font-line-height-breakpoint-medium: 1.43;
  --beacon-accordion-label-font-line-height-breakpoint-large: 1.75;
  --beacon-accordion-label-font-size-breakpoint-default: 0.75rem;
  --beacon-accordion-label-font-size-breakpoint-medium: 0.875rem;
  --beacon-accordion-label-font-size-breakpoint-large: 1.5rem;
  --beacon-accordion-label-font-weight: bold;
  --beacon-accordion-label-size-border-primary-default: 0px;
  --beacon-accordion-label-size-border-secondary-default: 1px;
  --beacon-accordion-label-size-width: 100%;
  --beacon-accordion-label-space-margin-large: calc(16px - 1px);
  --beacon-accordion-label-space-margin-x-large: calc(16px * 2);
  --beacon-accordion-label-space-padding-breakpoint-default: calc(16px - 1px);
  --beacon-accordion-label-space-padding-breakpoint-medium: calc(16px - 6px);
  --beacon-button-border-size-radius: 4px;
  --beacon-button-border-size-width: 1px;
  --beacon-button-border-style: solid;
  --beacon-button-color-background-negative-default: #dd3636;
  --beacon-button-color-background-negative-disabled-on-dark: #66737e;
  --beacon-button-color-background-negative-disabled-on-light: #929ba3;
  --beacon-button-color-background-negative-hover: #da2525;
  --beacon-button-color-background-negative-pressed: #c92222;
  --beacon-button-color-background-positive-default: #248647;
  --beacon-button-color-background-positive-disabled-on-dark: #66737e;
  --beacon-button-color-background-positive-disabled-on-light: #929ba3;
  --beacon-button-color-background-positive-hover: #1f753e;
  --beacon-button-color-background-positive-pressed: #1b6435;
  --beacon-button-color-background-primary-default-on-dark: #007db3;
  --beacon-button-color-background-primary-default-on-light: #086ea1;
  --beacon-button-color-background-primary-disabled-on-dark: #66737e;
  --beacon-button-color-background-primary-disabled-on-light: #929ba3;
  --beacon-button-color-background-primary-hover-on-dark: #006e9e;
  --beacon-button-color-background-primary-hover-on-light: #07608d;
  --beacon-button-color-background-primary-pressed-on-dark: #00608a;
  --beacon-button-color-background-primary-pressed-on-light: #065379;
  --beacon-button-color-background-secondary-hover-on-dark: rgba(255, 255, 255, 0.08);
  --beacon-button-color-background-secondary-hover-on-light: rgba(8, 110, 161, 0.08);
  --beacon-button-color-background-secondary-pressed-on-dark: rgba(255, 255, 255, 0.12);
  --beacon-button-color-background-secondary-pressed-on-light: rgba(8, 110, 161, 0.12);
  --beacon-button-color-border-negative-default: #dd3636;
  --beacon-button-color-border-negative-disabled-on-dark: #66737e;
  --beacon-button-color-border-negative-disabled-on-light: #929ba3;
  --beacon-button-color-border-negative-hover: #da2525;
  --beacon-button-color-border-negative-pressed: #c92222;
  --beacon-button-color-border-positive-default: #248647;
  --beacon-button-color-border-positive-disabled-on-dark: #66737e;
  --beacon-button-color-border-positive-disabled-on-light: #929ba3;
  --beacon-button-color-border-positive-hover: #1f753e;
  --beacon-button-color-border-positive-pressed: #1b6435;
  --beacon-button-color-border-primary-default-on-dark: #007db3;
  --beacon-button-color-border-primary-default-on-light: #086ea1;
  --beacon-button-color-border-primary-disabled-on-dark: #66737e;
  --beacon-button-color-border-primary-disabled-on-light: #929ba3;
  --beacon-button-color-border-primary-hover-on-dark: #006e9e;
  --beacon-button-color-border-primary-hover-on-light: #07608d;
  --beacon-button-color-border-primary-pressed-on-dark: #00608a;
  --beacon-button-color-border-primary-pressed-on-light: #065379;
  --beacon-button-color-border-secondary-default-on-dark: #ffffff;
  --beacon-button-color-border-secondary-default-on-light: #086ea1;
  --beacon-button-color-border-secondary-hover-on-dark: #ffffff;
  --beacon-button-color-border-secondary-hover-on-light: #07608d;
  --beacon-button-color-border-secondary-pressed-on-dark: #ffffff;
  --beacon-button-color-border-secondary-pressed-on-light: #065379;
  --beacon-button-color-border-tertiary-on-dark: #ffffff;
  --beacon-button-color-border-tertiary-on-light: #086ea1;
  --beacon-button-color-text-negative-default: rgba(255, 255, 255, 1);
  --beacon-button-color-text-negative-disabled-on-dark: #a8afb5;
  --beacon-button-color-text-negative-disabled-on-light: #d3d7da;
  --beacon-button-color-text-positive-default: rgba(255, 255, 255, 1);
  --beacon-button-color-text-positive-disabled-on-dark: #a8afb5;
  --beacon-button-color-text-positive-disabled-on-light: #d3d7da;
  --beacon-button-color-text-primary-default: rgba(255, 255, 255, 1);
  --beacon-button-color-text-primary-disabled-on-dark: #a8afb5;
  --beacon-button-color-text-primary-disabled-on-light: #d3d7da;
  --beacon-button-color-text-secondary-default-on-dark: rgba(255, 255, 255, 1);
  --beacon-button-color-text-secondary-default-on-light: #086ea1;
  --beacon-button-color-text-secondary-disabled-on-dark: #7c8790;
  --beacon-button-color-text-secondary-disabled-on-light: #929ba3;
  --beacon-button-color-text-secondary-hover-on-dark: rgba(255, 255, 255, 1);
  --beacon-button-color-text-secondary-hover-on-light: #07608d;
  --beacon-button-color-text-secondary-pressed-on-dark: rgba(255, 255, 255, 1);
  --beacon-button-color-text-secondary-pressed-on-light: #065379;
  --beacon-button-color-text-tertiary-default-on-dark: rgba(255, 255, 255, 1);
  --beacon-button-color-text-tertiary-default-on-light: #086ea1;
  --beacon-button-color-text-tertiary-disabled-on-dark: #7c8790;
  --beacon-button-color-text-tertiary-disabled-on-light: #929ba3;
  --beacon-button-font-family: Nimbus Sans Novus Bold, Helvetica, Arial, sans-serif;
  --beacon-button-font-letter-spacing: 0.0012em;
  --beacon-button-font-line-height-mini: 16px;
  --beacon-button-font-line-height-normal: 16px;
  --beacon-button-font-line-height-jumbo-breakpoint-default: 16px;
  --beacon-button-font-line-height-jumbo-breakpoint-medium: 1.25rem;
  --beacon-button-font-line-height-jumbo-breakpoint-large: 1.25rem;
  --beacon-button-font-line-height-jumbo-breakpoint-x-large: 1.25rem;
  --beacon-button-font-size-mini: 0.875rem;
  --beacon-button-font-size-normal: 1rem;
  --beacon-button-font-size-jumbo-breakpoint-default: 1rem;
  --beacon-button-font-size-jumbo-breakpoint-medium: 1rem;
  --beacon-button-font-size-jumbo-breakpoint-large: 1.125rem;
  --beacon-button-font-size-jumbo-breakpoint-x-large: 1.125rem;
  --beacon-button-size-height-mini: 32px;
  --beacon-button-size-height-normal: 40px;
  --beacon-button-size-height-jumbo: 48px;
  --beacon-button-size-height-active: 40px;
  --beacon-button-space-padding-down-mini: 6px;
  --beacon-button-space-padding-down-normal: 10px;
  --beacon-button-space-padding-down-jumbo-breakpoint-default: 14px;
  --beacon-button-space-padding-down-jumbo-breakpoint-medium: 12px;
  --beacon-button-space-padding-down-jumbo-breakpoint-large: 12px;
  --beacon-button-space-padding-down-jumbo-breakpoint-x-large: 12px;
  --beacon-button-space-padding-horizontal-mini: 12px;
  --beacon-button-space-padding-horizontal-normal: 16px;
  --beacon-button-space-padding-horizontal-jumbo: 24px;
  --beacon-button-space-padding-up-mini: 10px;
  --beacon-button-space-padding-up-normal: 14px;
  --beacon-button-space-padding-up-jumbo-breakpoint-default: 18px;
  --beacon-button-space-padding-up-jumbo-breakpoint-medium: 16px;
  --beacon-button-space-padding-up-jumbo-breakpoint-large: 16px;
  --beacon-button-space-padding-up-jumbo-breakpoint-x-large: 16px;
  --beacon-checkbox-icon-background: url("data:image/svg+xml,%3Csvg width='15' height='13' viewBox='0 0 15 13' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M1 7.51852L5.78947 12L14 1' stroke='white' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E%0A");
  --beacon-checkbox-icon-color-background-default: #ffffff;
  --beacon-checkbox-icon-color-background-inactive: #ffffff00;
  --beacon-checkbox-icon-color-fill-default-on-dark: #007db3;
  --beacon-checkbox-icon-color-fill-default-on-light: #086ea1;
  --beacon-checkbox-icon-color-fill-inactive-on-dark: #7c8790;
  --beacon-checkbox-icon-color-fill-inactive-on-light: #929ba3;
  --beacon-checkbox-input-color-border-default-on-dark: #515f6b;
  --beacon-checkbox-input-color-border-default-on-light: #bec3c8;
  --beacon-checkbox-input-color-border-inactive-on-light: #d3d7da;
  --beacon-checkbox-input-color-border-on-light: #bec3c8;
  --beacon-checkbox-input-color-outline-on-dark: #ffffff;
  --beacon-checkbox-input-color-outline-on-light: #086ea1;
  --beacon-checkbox-input-size-border-radius: 2px;
  --beacon-checkbox-input-size-dimension: 28px;
  --beacon-checkbox-input-space-padding: 2px;
  --beacon-checkbox-label-color-text-default-on-dark: #d3d7da;
  --beacon-checkbox-label-color-text-default-on-light: #3b4b59;
  --beacon-checkbox-label-color-text-inactive-on-light: #929ba3;
  --beacon-checkbox-label-color-text-on-light: #3b4b59;
  --beacon-checkbox-label-font-family-pressed: Nimbus Sans Novus Bold, Helvetica, Arial, sans-serif;
  --beacon-checkbox-label-font-line-height-breakpoint-default: 1.43;
  --beacon-checkbox-label-font-line-height-breakpoint-medium: 1.50;
  --beacon-checkbox-label-font-line-height-breakpoint-x-large: 1.56;
  --beacon-checkbox-label-font-size-breakpoint-default: 0.875rem;
  --beacon-checkbox-label-font-size-breakpoint-medium: 1rem;
  --beacon-checkbox-label-font-size-breakpoint-x-large: 1.125rem;
  --beacon-checkbox-label-space-margin: 12px;
  --beacon-country-language-color-border: #e9ebed;
  --beacon-country-language-color-link: #086ea1;
  --beacon-country-language-color-text: #3b4b59;
  --beacon-country-language-flag-icon-size-height: 16px;
  --beacon-country-language-font-line-height-breakpoint-default: 1.43;
  --beacon-country-language-font-line-height-breakpoint-medium: 1.50;
  --beacon-country-language-font-size-breakpoint-default: 0.875rem;
  --beacon-country-language-font-size-breakpoint-medium: 1rem;
  --beacon-country-language-space-margin-small: calc(4px);
  --beacon-country-language-space-margin-medium: calc(4px * 2);
  --beacon-country-language-space-margin-large: calc(4px * 4);
  --beacon-country-language-space-padding-small: calc(4px * 2);
  --beacon-country-language-space-padding-medium: calc(4px * 3.75);
  --beacon-country-language-space-padding-large: calc(4px * 5);
  --beacon-date-picker-color-text-active: #3b4b59;
  --beacon-date-picker-color-text-inactive: #929ba3;
  --beacon-date-picker-font-line-height-breakpoint-default: 1.43;
  --beacon-date-picker-font-line-height-breakpoint-x-large: 1.56;
  --beacon-date-picker-font-size-breakpoint-default: 0.875rem;
  --beacon-date-picker-font-size-breakpoint-medium: 1rem;
  --beacon-date-picker-font-size-breakpoint-x-large: 1.125rem;
  --beacon-date-picker-icon-background-active: no-repeat url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 16 16' fill='none'%3E%3Crect width='16' height='16' fill='%23F4F5F6'/%3E%3Crect x='-924' y='-973' width='2002' height='2629' fill='white'/%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M3.25 1V2.00004H2.33325C1.78097 2.00004 1.33325 2.44776 1.33325 3.00004V4.33337V14.3334C1.33325 14.8857 1.78097 15.3334 2.33325 15.3334H13.6666C14.2189 15.3334 14.6666 14.8857 14.6666 14.3334V4.33337V3.00004C14.6666 2.44776 14.2189 2.00004 13.6666 2.00004H12.75V1C12.75 0.585786 12.4142 0.25 12 0.25C11.5858 0.25 11.25 0.585786 11.25 1V2.00004H4.75V1C4.75 0.585786 4.41421 0.25 4 0.25C3.58579 0.25 3.25 0.585786 3.25 1ZM13.6666 5.33337H2.33325V14.3334L13.6666 14.3334V5.33337Z' fill='%23086EA1'/%3E%3Crect x='-924' y='-973' width='2002' height='2629' stroke='%23BEC3C8' stroke-width='2'/%3E%3C/svg%3E");
  --beacon-date-picker-icon-background-inactive: no-repeat url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 16 16' fill='none'%3E%3Crect width='16' height='16' fill='%23F4F5F6'/%3E%3Crect x='-924' y='-973' width='2002' height='2629' fill='white'/%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M3.25 1V2.00004H2.33325C1.78097 2.00004 1.33325 2.44776 1.33325 3.00004V4.33337V14.3334C1.33325 14.8857 1.78097 15.3334 2.33325 15.3334H13.6666C14.2189 15.3334 14.6666 14.8857 14.6666 14.3334V4.33337V3.00004C14.6666 2.44776 14.2189 2.00004 13.6666 2.00004H12.75V1C12.75 0.585786 12.4142 0.25 12 0.25C11.5858 0.25 11.25 0.585786 11.25 1V2.00004H4.75V1C4.75 0.585786 4.41421 0.25 4 0.25C3.58579 0.25 3.25 0.585786 3.25 1ZM13.6666 5.33337H2.33325V14.3334L13.6666 14.3334V5.33337Z' fill='%237C8790'/%3E%3Crect x='-924' y='-973' width='2002' height='2629' stroke='%23BEC3C8' stroke-width='2'/%3E%3C/svg%3E");
  --beacon-date-picker-icon-size-border-radius: 1px;
  --beacon-date-picker-icon-size-height-breakpoint-default: 16px;
  --beacon-date-picker-icon-size-height-breakpoint-x-large: 18px;
  --beacon-date-picker-icon-size-width-breakpoint-default: 16px;
  --beacon-date-picker-icon-size-width-breakpoint-x-large: 18px;
  --beacon-date-picker-icon-space-left: 7px;
  --beacon-date-picker-icon-space-right-breakpoint-default: 5px;
  --beacon-date-picker-icon-space-right-breakpoint-x-large: 10px;
  --beacon-date-picker-icon-space-top-breakpoint-default: calc(50% - 18px/2 + 0.67px);
  --beacon-date-picker-icon-space-top-breakpoint-medium: calc(50% - 19px/2 + 0.67px);
  --beacon-date-picker-icon-space-top-breakpoint-x-large: calc(50% - 18px/2 + 0.67px);
  --beacon-date-picker-size-width-breakpoint-default: 105px;
  --beacon-date-picker-size-width-breakpoint-medium: 116px;
  --beacon-date-picker-size-width-breakpoint-x-large: 127px;
  --beacon-date-picker-space-left: 5px;
  --beacon-date-picker-space-top-breakpoint-default: calc(50% - 22px/2 - 1px);
  --beacon-date-picker-space-top-breakpoint-medium: calc(50% - 24px/2 - 1px);
  --beacon-date-picker-space-top-breakpoint-x-large: calc(50% - 26px/2 - 1px);
  --beacon-date-picker-wrapper-color-background-color: #ffffff;
  --beacon-date-picker-wrapper-color-border: 1.5px solid rgba(190, 195, 200, 1);
  --beacon-date-picker-wrapper-color-outline-on-dark: #ffffff;
  --beacon-date-picker-wrapper-color-outline-on-light: #086ea1;
  --beacon-date-picker-wrapper-size-border-radius: 4px;
  --beacon-date-picker-wrapper-size-height: 40px;
  --beacon-date-picker-wrapper-size-width-breakpoint-default: 136px;
  --beacon-date-picker-wrapper-size-width-breakpoint-medium: 148px;
  --beacon-date-picker-wrapper-size-width-breakpoint-x-large: 160px;
  --beacon-dropdown-color-background: #ffffff;
  --beacon-dropdown-color-border: #bec3c8;
  --beacon-dropdown-color-text-default: #3b4b59;
  --beacon-dropdown-color-text-disabled: #929ba3;
  --beacon-dropdown-icon-default: url("data:image/svg+xml,%3Csvg width='10' height='6' viewBox='0 0 10 6' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M9 1L5 5L1 1' stroke='%23086EA1' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E");
  --beacon-dropdown-icon-disabled: url("data:image/svg+xml,%3Csvg width='10' height='6' viewBox='0 0 10 6' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M9 1L5 5L1 1' stroke='%23929BA3' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E");
  --beacon-dropdown-size-border-radius: 4px;
  --beacon-dropdown-size-height: 40px;
  --beacon-dropdown-space-background-position: right 16px top 50%;
  --beacon-dropdown-space-padding: 0 calc(2 * 16px + 8px) 0 calc(4px + 8px);
  --beacon-error-color-text-on-dark: #ffffff;
  --beacon-error-color-text-on-light: #3b4b59;
  --beacon-error-font-line-height-breakpoint-default: 1rem;
  --beacon-error-font-line-height-breakpoint-medium: 1.25rem;
  --beacon-error-font-line-height-breakpoint-large: 1.25rem;
  --beacon-error-font-line-height-breakpoint-x-large: 1.5rem;
  --beacon-error-font-size-breakpoint-default: 0.75rem;
  --beacon-error-font-size-breakpoint-medium: 0.875rem;
  --beacon-error-font-size-breakpoint-large: 0.875rem;
  --beacon-error-font-size-breakpoint-x-large: 1rem;
  --beacon-error-font-weight: Nimbus Sans Novus Bold, Helvetica, Arial, sans-serif;
  --beacon-error-icon: no-repeat url("data:image/svg+xml,%3Csvg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Ccircle cx='8' cy='8' r='8' fill='%23DD3636'/%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M8 3.75C7.72386 3.75 7.5 3.97386 7.5 4.25V9.25C7.5 9.52614 7.72386 9.75 8 9.75C8.27614 9.75 8.5 9.52614 8.5 9.25V4.25C8.5 3.97386 8.27614 3.75 8 3.75ZM8 12.25C8.41421 12.25 8.75 11.9142 8.75 11.5C8.75 11.0858 8.41421 10.75 8 10.75C7.58579 10.75 7.25 11.0858 7.25 11.5C7.25 11.9142 7.58579 12.25 8 12.25Z' fill='white'/%3E%3C/svg%3E%0A");
  --beacon-error-size-height: 20px;
  --beacon-error-size-width: 20px;
  --beacon-error-space-margin-bottom: 4px;
  --beacon-error-space-margin-left: 10px;
  --beacon-error-space-padding-top: 4px;
  --beacon-header-action-zone-color-text: #ffffff;
  --beacon-header-action-zone-font-line-height: 1.43;
  --beacon-header-action-zone-font-size: 0.875rem;
  --beacon-header-action-zone-space-margin-medium: calc(4px + 3px);
  --beacon-header-action-zone-space-margin-large: calc(8px * 3);
  --beacon-header-action-zone-space-padding-medium: calc(16px + 8px);
  --beacon-header-action-zone-space-padding-large: calc(16px + 4px);
  --beacon-header-brandmark-size-height: calc(16px * 4);
  --beacon-header-color-background: #1e2d39;
  --beacon-header-hamburger-icon: center no-repeat url("data:image/svg+xml,%3Csvg width='32' height='32' viewBox='0 0 32 32' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M8 16L24 16' stroke='white' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round' /%3E%3Cpath d='M8 22L24 22' stroke='white' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round' /%3E%3Cpath d='M8 10L24 10' stroke='white' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round' /%3E%3C/svg%3E");
  --beacon-header-hamburger-size-height: calc(4px * 7.5);
  --beacon-header-hamburger-size-width: calc(4px * 7.5);
  --beacon-header-navigation-icon-color: #ffffff;
  --beacon-header-size-height: calc(16px * 4);
  --beacon-header-word-mark-border-small: calc(4px / 2);
  --beacon-header-word-mark-border-default: #007db3;
  --beacon-header-word-mark-space-margin-large: calc(16px + 6px);
  --beacon-header-word-mark-space-margin-x-large: calc(16px * 2);
  --beacon-header-word-mark-space-padding-medium: calc(16px + 8px);
  --beacon-header-word-mark-space-padding-large: calc(16px + 3px);
  --beacon-header-word-mark-space-padding-x-large: calc(16px * 2);
  --beacon-headerbar-link-color-background: #1e2d39;
  --beacon-headerbar-link-color-border: #e9ebed;
  --beacon-headerbar-link-color-text-breakpoint-small: #086ea1;
  --beacon-headerbar-link-color-text-breakpoint-large: #ffffff;
  --beacon-headerbar-link-font-family: Nimbus Sans Novus Regular, Helvetica, Arial, sans-serif;
  --beacon-headerbar-link-font-size-breakpoint-small: 1.50;
  --beacon-headerbar-link-font-size-breakpoint-large: 0.875rem;
  --beacon-headerbar-link-font-weight: 700;
  --beacon-headerbar-link-size-height: calc(16px * 4);
  --beacon-headerbar-link-space-padding-small: calc(4px * 2);
  --beacon-headerbar-link-space-padding-medium: calc(4px * 3.75);
  --beacon-headerbar-link-space-padding-large: calc(4px * 5);
  --beacon-headerbar-link-space-padding-x-large: calc(16px * 2);
  --beacon-hero-button-size-border-radius: 4px;
  --beacon-hero-button-space-margin: calc(5 * 4px);
  --beacon-hero-button-space-padding-breakpoint-small: calc(3* 16px + 2px);
  --beacon-hero-button-space-padding-breakpoint-medium: calc(3 * 16px);
  --beacon-hero-button-space-padding-breakpoint-large: calc(7 * 8px);
  --beacon-hero-link-font-line-height-breakpoint-medium: 16px;
  --beacon-hero-link-font-line-height-breakpoint-large: calc(5 * 4px);
  --beacon-hero-link-font-size-breakpoint-small: 0.875rem;
  --beacon-hero-link-font-size-breakpoint-large: 1.125rem;
  --beacon-hero-link-space-margin-breakpoint-medium: 16px;
  --beacon-hero-link-space-margin-breakpoint-large: calc(5 * 4px);
  --beacon-hero-link-space-margin-breakpoint-x-large: calc(3 * 8px);
  --beacon-hero-link-space-padding: calc( 16px + 2px);
  --beacon-hero-text-body-font-line-height-breakpoint-large: 1.17;
  --beacon-hero-text-body-font-line-height-breakpoint-x-large: 1.14;
  --beacon-hero-text-body-font-size-breakpoint-large: 3rem;
  --beacon-hero-text-body-font-size-breakpoint-x-large: 3.5rem;
  --beacon-hero-text-body-space-padding-breakpoint-default: 16px;
  --beacon-hero-text-footer-font-letter-spacing: 0.0012em;
  --beacon-hero-text-footer-font-line-height-breakpoint-small: 1.50;
  --beacon-hero-text-footer-font-line-height-breakpoint-medium: 1.33;
  --beacon-hero-text-footer-font-line-height-breakpoint-large: 1.33;
  --beacon-hero-text-footer-font-line-height-breakpoint-x-large: 1.40;
  --beacon-hero-text-footer-font-size-breakpoint-small: 1rem;
  --beacon-hero-text-footer-font-size-breakpoint-medium: 1.125rem;
  --beacon-hero-text-footer-font-size-breakpoint-large: 1.125rem;
  --beacon-hero-text-footer-font-size-breakpoint-x-large: 1.25rem;
  --beacon-hero-text-footer-space-padding-breakpoint-large: 16px;
  --beacon-hero-text-footer-space-padding-breakpoint-x-large: calc(3 * 8px);
  --beacon-hero-text-header-font-letter-spacing: 0.0012em;
  --beacon-hero-text-header-font-line-height-breakpoint-small: 1.33;
  --beacon-hero-text-header-font-line-height-breakpoint-medium: 1.43;
  --beacon-hero-text-header-font-line-height-breakpoint-large: 1.43;
  --beacon-hero-text-header-font-line-height-breakpoint-x-large: 1.50;
  --beacon-hero-text-header-font-size-breakpoint-small: 0.75rem;
  --beacon-hero-text-header-font-size-breakpoint-medium: 0.875rem;
  --beacon-hero-text-header-font-size-breakpoint-large: 0.875rem;
  --beacon-hero-text-header-font-size-breakpoint-x-large: 1rem;
  --beacon-hero-text-wrapper-color-background-on-dark: #ffffff;
  --beacon-hero-text-wrapper-color-background-on-light: #1e2d39;
  --beacon-hero-text-wrapper-size-border-radius: 4px;
  --beacon-hero-text-wrapper-space-padding-breakpoint-small: calc(4 * 8px);
  --beacon-hero-text-wrapper-space-padding-breakpoint-medium: calc(3 * 8px);
  --beacon-hero-text-wrapper-space-padding-breakpoint-large: calc(4 * 8px);
  --beacon-hero-wrapper-container-color-background-on-dark: #1e2d39;
  --beacon-hero-wrapper-container-color-background-on-light: rgba(249, 250, 250, 1);
  --beacon-hero-wrapper-container-size-width-breakpoint-large: calc(103 * 4px);
  --beacon-hero-wrapper-container-size-width-breakpoint-x-large: calc(135 * 4px);
  --beacon-hero-wrapper-container-space-bottom: 50%;
  --beacon-hero-wrapper-container-space-margin-breakpoint-large: calc(7 * 8px);
  --beacon-hero-wrapper-container-space-margin-breakpoint-x-large: calc(11 * 8px);
  --beacon-hero-wrapper-container-space-top-breakpoint-large: calc(19 * 4px);
  --beacon-hero-wrapper-container-space-top-breakpoint-x-large: calc(16 * 16px);
  --beacon-input-button-field-button-color-background: rgba(255, 255, 255, 1);
  --beacon-input-button-field-button-size-border-radius: 0 4px 4px 0;
  --beacon-input-button-field-button-space-margin: 0 0 0 -2px;
  --beacon-input-button-field-button-space-padding: calc(4px + 8px);
  --beacon-input-button-field-caret-color: #05c3de;
  --beacon-input-button-field-color-background: #ffffff;
  --beacon-input-button-field-color-border: #bec3c8;
  --beacon-input-button-field-color-text-default: #3b4b59;
  --beacon-input-button-field-color-text-disabled: #929ba3;
  --beacon-input-button-field-icon-space-padding: 40px;
  --beacon-input-button-field-icon-space-position-left: left calc(8px + 4px) top 50%;
  --beacon-input-button-field-icon-space-position-right: right calc(8px + 4px) top 50%;
  --beacon-input-button-field-size-border-radius: 4px 0px 0px 4px;
  --beacon-input-button-field-size-border-right: none;
  --beacon-input-button-field-size-height: 40px;
  --beacon-input-button-field-space-padding: 0 0 0 calc(4px + 8px);
  --beacon-input-button-field-vertical-divider-color-background: #e9ebed;
  --beacon-input-button-field-vertical-divider-size-width: 1px;
  --beacon-input-button-field-vertical-divider-space-margin: 12px 0;
  --beacon-locale-selector-chevron-arrow-size-height: calc(4px * 2);
  --beacon-locale-selector-chevron-arrow-size-width: 4px;
  --beacon-locale-selector-color-border: #e9ebed;
  --beacon-locale-selector-color-link: #086ea1;
  --beacon-locale-selector-color-text: #3b4b59;
  --beacon-locale-selector-font-family: Nimbus Sans Novus Bold, Helvetica, Arial, sans-serif;
  --beacon-locale-selector-font-line-height-small: 1.43;
  --beacon-locale-selector-font-line-height-medium: 1.50;
  --beacon-locale-selector-font-size-small: 0.875rem;
  --beacon-locale-selector-font-size-medium: 1rem;
  --beacon-locale-selector-space-margin-x-small: 4px;
  --beacon-locale-selector-space-margin-small: calc(4px * 2);
  --beacon-locale-selector-space-margin-medium: calc(4px * 3);
  --beacon-locale-selector-space-margin-large: calc(4px * 8);
  --beacon-locale-selector-space-margin-x-large: calc(4px * 10);
  --beacon-locale-selector-space-padding-small: calc(4px);
  --beacon-locale-selector-space-padding-medium: calc(4px * 2);
  --beacon-locale-selector-space-padding-large: calc(4px * 3);
  --beacon-localization-container-color-link: #086ea1;
  --beacon-localization-container-color-text: #3b4b59;
  --beacon-localization-container-font-family: Nimbus Sans Novus Bold, Helvetica, Arial, sans-serif;
  --beacon-localization-container-font-line-height-breakpoint-default: 1.50;
  --beacon-localization-container-font-line-height-breakpoint-medium: 1.43;
  --beacon-localization-container-font-size-breakpoint-default: 1rem;
  --beacon-localization-container-font-size-breakpoint-medium: 1.75rem;
  --beacon-localization-container-space-margin-x-small: 4px;
  --beacon-localization-container-space-margin-small: calc(4px * 4);
  --beacon-localization-container-space-margin-medium: calc(4px * 10.5);
  --beacon-localization-container-space-padding-x-small: calc(4px);
  --beacon-localization-container-space-padding-small: calc(4px * 4);
  --beacon-localization-container-space-padding-medium: calc(4px * 5);
  --beacon-localization-container-space-padding-large: calc(4px * 13);
  --beacon-localization-container-space-padding-x-large: calc(4px * 17);
  --beacon-long-form-caption-font-line-height-normal-breakpoint-default: 1.33em;
  --beacon-long-form-caption-font-line-height-normal-breakpoint-medium: 1.43em;
  --beacon-long-form-caption-font-line-height-normal-breakpoint-large: 1.43em;
  --beacon-long-form-caption-font-line-height-normal-breakpoint-x-large: 1.50em;
  --beacon-long-form-caption-font-line-height-x-small-breakpoint-default: 1.60em;
  --beacon-long-form-caption-font-line-height-x-small-breakpoint-medium: 1.60em;
  --beacon-long-form-caption-font-line-height-x-small-breakpoint-large: 1.60em;
  --beacon-long-form-caption-font-line-height-x-small-breakpoint-x-large: 1.33em;
  --beacon-long-form-caption-font-line-height-small-breakpoint-default: 1.60em;
  --beacon-long-form-caption-font-line-height-small-breakpoint-medium: 1.33em;
  --beacon-long-form-caption-font-line-height-small-breakpoint-large: 1.33em;
  --beacon-long-form-caption-font-line-height-small-breakpoint-x-large: 1.43em;
  --beacon-long-form-h1-font-line-height-breakpoint-default: 1.20em;
  --beacon-long-form-h1-font-line-height-breakpoint-medium: 1.14em;
  --beacon-long-form-h1-font-line-height-breakpoint-large: 1.14em;
  --beacon-long-form-h1-font-line-height-breakpoint-x-large: 1.11em;
  --beacon-long-form-h2-font-line-height-breakpoint-default: 1.38em;
  --beacon-long-form-h2-font-line-height-breakpoint-medium: 1.33em;
  --beacon-long-form-h2-font-line-height-breakpoint-large: 1.33em;
  --beacon-long-form-h2-font-line-height-breakpoint-x-large: 1.20em;
  --beacon-long-form-h3-font-line-height-breakpoint-default: 1.43em;
  --beacon-long-form-h3-font-line-height-breakpoint-medium: 1.38em;
  --beacon-long-form-h3-font-line-height-breakpoint-large: 1.38em;
  --beacon-long-form-h3-font-line-height-breakpoint-x-large: 1.33em;
  --beacon-long-form-h4-font-line-height-breakpoint-default: 1.33em;
  --beacon-long-form-h4-font-line-height-breakpoint-medium: 1.43em;
  --beacon-long-form-h4-font-line-height-breakpoint-large: 1.43em;
  --beacon-long-form-h4-font-line-height-breakpoint-x-large: 1.38em;
  --beacon-long-form-h5-font-line-height-breakpoint-default: 1.60em;
  --beacon-long-form-h5-font-line-height-breakpoint-medium: 1.33em;
  --beacon-long-form-h5-font-line-height-breakpoint-large: 1.33em;
  --beacon-long-form-h5-font-line-height-breakpoint-x-large: 1.38em;
  --beacon-long-form-h6-font-line-height-breakpoint-default: 1.50em;
  --beacon-long-form-h6-font-line-height-breakpoint-medium: 1.56em;
  --beacon-long-form-h6-font-line-height-breakpoint-large: 1.56em;
  --beacon-long-form-h6-font-line-height-breakpoint-x-large: 1.60em;
  --beacon-long-form-p-font-line-height-breakpoint-default: 1.56em;
  --beacon-long-form-p-font-line-height-breakpoint-medium: 1.60em;
  --beacon-long-form-p-font-line-height-breakpoint-large: 1.60em;
  --beacon-long-form-p-font-line-height-breakpoint-x-large: 1.33em;
  --beacon-modal-action-button-space-margin: 0 0 0 calc(16px * 2);
  --beacon-modal-action-zone-color-background: #f9fafa;
  --beacon-modal-action-zone-elevation: 0px -2px 0px -1px rgba(146, 155, 163, .4);
  --beacon-modal-action-zone-size-border-radius: 0 0 4px 4px;
  --beacon-modal-action-zone-size-height-breakpoint-default: calc(4 * 16px + 8px);
  --beacon-modal-action-zone-size-height-breakpoint-large: calc(5 * 16px);
  --beacon-modal-action-zone-size-width: 100%;
  --beacon-modal-action-zone-space-padding-breakpoint-default: calc(8px * 2) calc(8px * 2 + 4px);
  --beacon-modal-action-zone-space-padding-breakpoint-large: calc(12px + 8px) calc(12px + 8px + 4px);
  --beacon-modal-body-font-line-height-breakpoint-default: 1.50;
  --beacon-modal-body-font-line-height-breakpoint-medium: 1.33;
  --beacon-modal-body-font-line-height-breakpoint-large: 1.33;
  --beacon-modal-body-font-line-height-breakpoint-x-large: 1.40;
  --beacon-modal-body-font-size-breakpoint-default: 1rem;
  --beacon-modal-body-font-size-breakpoint-medium: 1.125rem;
  --beacon-modal-body-font-size-breakpoint-large: 1.125rem;
  --beacon-modal-body-font-size-breakpoint-x-large: 1.25rem;
  --beacon-modal-body-font-weight: 400;
  --beacon-modal-body-space-padding-medium: 8px 8px calc(8px + 16px) 8px;
  --beacon-modal-body-space-padding-large: 12px 12px calc(12px + 16px) 12px;
  --beacon-modal-close-button-icon-on-dark: no-repeat url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='40' height='40' viewBox='0 0 40 40'%3E%3Cpath d='M27 13L13 27' stroke='%23FFFFFF' stroke-width='1.5' stroke-linecap='round'/%3E%3Cpath d='M27 27L13 13' stroke='%23FFFFFF' stroke-width='1.5' stroke-linecap='round'/%3E%3C/svg%3E");
  --beacon-modal-close-button-icon-on-light: no-repeat url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='40' height='40' viewBox='0 0 40 40'%3E%3Cpath d='M27 13L13 27' stroke='%23086EA1' stroke-width='1.5' stroke-linecap='round'/%3E%3Cpath d='M27 27L13 13' stroke='%23086EA1' stroke-width='1.5' stroke-linecap='round'/%3E%3C/svg%3E");
  --beacon-modal-close-button-size: 40px;
  --beacon-modal-color-background-primary: #ffffff;
  --beacon-modal-color-background-secondary: #f4f5f6;
  --beacon-modal-color-text: #3b4b59;
  --beacon-modal-elevation-level-0-on-dark: 0px 2px 0px -1px rgba(0, 47, 72, .4);
  --beacon-modal-elevation-level-0-on-light: 0px 2px 0px -1px rgba(146, 155, 163, .4);
  --beacon-modal-elevation-level-1-on-dark: 0px 2px 4px -2px rgba(0, 47, 72, .8);
  --beacon-modal-elevation-level-1-on-light: 0px 2px 4px -2px rgba(146, 155, 163, .8);
  --beacon-modal-elevation-level-2-on-dark: 0px 8px 12px -8px rgba(0, 47, 72, .64);
  --beacon-modal-elevation-level-2-on-light: 0px 8px 12px -8px rgba(146, 155, 163, .64);
  --beacon-modal-elevation-level-3-on-dark: 0px 16px 24px -16px rgba(0, 47, 72, .56);
  --beacon-modal-elevation-level-3-on-light: 0px 16px 24px -16px rgba(146, 155, 163, .48);
  --beacon-modal-font-text-align: left;
  --beacon-modal-header-color-background: #f9fafa;
  --beacon-modal-header-elevation: 0px 2px 0px -1px rgba(146, 155, 163, .4);
  --beacon-modal-header-size-border-radius: 4px 4px 0 0;
  --beacon-modal-header-size-height-breakpoint-default: calc(8px * 2 + 40px);
  --beacon-modal-header-size-height-breakpoint-large: calc(12px * 2 + 40px);
  --beacon-modal-header-size-width: 100%;
  --beacon-modal-layout-columns-mini-breakpoint-default: 6;
  --beacon-modal-layout-columns-mini-breakpoint-medium: 8;
  --beacon-modal-layout-columns-mini-breakpoint-large: 6;
  --beacon-modal-layout-columns-mini-breakpoint-x-large: 4;
  --beacon-modal-layout-columns-normal-breakpoint-default: 6;
  --beacon-modal-layout-columns-normal-breakpoint-medium: 10;
  --beacon-modal-layout-columns-normal-breakpoint-large: 8;
  --beacon-modal-layout-columns-normal-breakpoint-x-large: 6;
  --beacon-modal-layout-columns-jumbo-breakpoint-default: fullscreen;
  --beacon-modal-layout-columns-jumbo-breakpoint-medium: 12;
  --beacon-modal-layout-columns-jumbo-breakpoint-large: 10;
  --beacon-modal-layout-columns-jumbo-breakpoint-x-large: 8;
  --beacon-modal-layout-columns-maxi-breakpoint-default: fullscreen;
  --beacon-modal-layout-columns-maxi-breakpoint-medium: 12;
  --beacon-modal-layout-columns-maxi-breakpoint-large: 12;
  --beacon-modal-layout-columns-maxi-breakpoint-x-large: 12;
  --beacon-modal-size-border-radius: 4px;
  --beacon-modal-size-content-width: 100%;
  --beacon-modal-size-height-jumbo-breakpoint-default: 100vh;
  --beacon-modal-size-height-maxi-breakpoint-default: 100vh;
  --beacon-modal-size-max-height-breakpoint-default: calc(100vh - 2 * 0.5rem);
  --beacon-modal-size-max-height-breakpoint-medium: calc(100vh - 2 * 1rem);
  --beacon-modal-size-max-height-breakpoint-large: calc(100vh - 2 * 2rem);
  --beacon-modal-size-max-height-breakpoint-x-large: calc(100vh - 2 * 4rem);
  --beacon-modal-size-max-width-mini-breakpoint-default: calc(calc( ((100vw - (0rem*2)) - (calc(6 + 1) * 1rem)) / 6)*6 + (1rem*5));
  --beacon-modal-size-max-width-mini-breakpoint-medium: calc(calc( ((100vw - (1rem*2)) - (calc(12 + 1) * 1rem)) / 12)*8 + (1rem*calc(8 - 1)));
  --beacon-modal-size-max-width-mini-breakpoint-large: calc(calc( ((100vw - (2rem*2)) - (calc(12 + 1) * 1.5rem)) / 12)*6 + (1.5rem*calc(6 - 1)));
  --beacon-modal-size-max-width-mini-breakpoint-x-large: calc(calc( ((100vw - (4rem*2)) - (calc(12 + 1) * 1.5rem)) / 12)*4 + (1.5rem*calc(4 - 1)));
  --beacon-modal-size-max-width-normal-breakpoint-default: calc(calc( ((100vw - (0rem*2)) - (calc(6 + 1) * 1rem)) / 6)*6 + (1rem*5));
  --beacon-modal-size-max-width-normal-breakpoint-medium: calc(calc( ((100vw - (1rem*2)) - (calc(12 + 1) * 1rem)) / 12)*10 + (1rem*calc(10 - 1)));
  --beacon-modal-size-max-width-normal-breakpoint-large: calc(calc( ((100vw - (2rem*2)) - (calc(12 + 1) * 1.5rem)) / 12)*8 + (1.5rem*calc(8 - 1)));
  --beacon-modal-size-max-width-normal-breakpoint-x-large: calc(calc( ((100vw - (4rem*2)) - (calc(12 + 1) * 1.5rem)) / 12)*6 + (1.5rem*calc(6 - 1)));
  --beacon-modal-size-max-width-jumbo-breakpoint-default: 100vw;
  --beacon-modal-size-max-width-jumbo-breakpoint-medium: calc(calc( ((100vw - (1rem*2)) - (calc(12 + 1) * 1rem)) / 12)*12 + (1rem*calc(12 - 1)));
  --beacon-modal-size-max-width-jumbo-breakpoint-large: calc(calc( ((100vw - (2rem*2)) - (calc(12 + 1) * 1.5rem)) / 12)*10 + (1.5rem*calc(10 - 1)));
  --beacon-modal-size-max-width-jumbo-breakpoint-x-large: calc(calc( ((100vw - (4rem*2)) - (calc(12 + 1) * 1.5rem)) / 12)*8 + (1.5rem*calc(8 - 1)));
  --beacon-modal-size-max-width-maxi-breakpoint-default: 100vw;
  --beacon-modal-size-max-width-maxi-breakpoint-medium: calc(calc( ((100vw - (1rem*2)) - (calc(12 + 1) * 1rem)) / 12)*12 + (1rem*calc(12 - 1)));
  --beacon-modal-size-max-width-maxi-breakpoint-large: calc(calc( ((100vw - (2rem*2)) - (calc(12 + 1) * 1.5rem)) / 12)*12 + (1.5rem*calc(12 - 1)));
  --beacon-modal-size-max-width-maxi-breakpoint-x-large: calc(calc( ((100vw - (4rem*2)) - (calc(12 + 1) * 1.5rem)) / 12)*12 + (1.5rem*calc(12 - 1)));
  --beacon-modal-space-margin-small: 16px;
  --beacon-modal-space-margin-large: 40px;
  --beacon-modal-space-padding-small: 8px;
  --beacon-modal-space-padding-large: 12px;
  --beacon-modal-spacer-size-height: 16px;
  --beacon-modal-title-font-family: Nimbus Sans Novus Bold, Helvetica, Arial, sans-serif;
  --beacon-modal-title-font-line-height-breakpoint-default: 1.40;
  --beacon-modal-title-font-line-height-breakpoint-medium: 1.33;
  --beacon-modal-title-font-line-height-breakpoint-large: 1.33;
  --beacon-modal-title-font-line-height-breakpoint-x-large: 1.29;
  --beacon-modal-title-font-size-breakpoint-default: 1.25rem;
  --beacon-modal-title-font-size-breakpoint-medium: 1.5rem;
  --beacon-modal-title-font-size-breakpoint-large: 1.5rem;
  --beacon-modal-title-font-size-breakpoint-x-large: 1.75rem;
  --beacon-modal-title-font-weight: 700;
  --beacon-modal-title-space-padding-medium: calc(8px + 8px) 8px 8px 8px;
  --beacon-modal-title-space-padding-large: calc(12px + 8px) 12px 12px 12px;
  --beacon-modal-wrapper-size-height: 100vh;
  --beacon-modal-zones-wrapper-size-height: 100%;
  --beacon-modal-zones-wrapper-space-padding-breakpoint-default: 16px;
  --beacon-modal-zones-wrapper-space-padding-breakpoint-medium: calc(2 * 16px + 8px);
  --beacon-navigation-color-border: #e9ebed;
  --beacon-navigation-duration-ease-out: ease-out;
  --beacon-navigation-duration-half-second: .5s;
  --beacon-navigation-duration-linear: linear;
  --beacon-navigation-duration-quarter-second: .25s;
  --beacon-navigation-duration-tenth-second: .1s;
  --beacon-navigation-font-family-bold: Nimbus Sans Novus Bold, Helvetica, Arial, sans-serif;
  --beacon-navigation-font-family-regular: Nimbus Sans Novus Regular, Helvetica, Arial, sans-serif;
  --beacon-navigation-heading-font-line-height: 1.29em;
  --beacon-navigation-heading-font-size: 1.75rem;
  --beacon-navigation-item-color-border-active: rgba(5, 195, 222, 1);
  --beacon-navigation-item-color-border-hover: rgba(5, 195, 222, 1);
  --beacon-navigation-item-font-line-height: 1.33em;
  --beacon-navigation-item-font-size: 1rem;
  --beacon-navigation-pane-color-background: rgba(255, 255, 255, 1);
  --beacon-navigation-pane-color-border: rgba(233, 235, 237, 1);
  --beacon-navigation-size-border-small: 1px;
  --beacon-navigation-size-border-medium: calc(1px + 1px);
  --beacon-navigation-size-height-small-breakpoint-default: calc(4px + 2px);
  --beacon-navigation-size-height-small-breakpoint-medium: 4px;
  --beacon-navigation-size-height-medium-breakpoint-default: calc(4px * 3);
  --beacon-navigation-size-height-medium-breakpoint-medium: 4px;
  --beacon-navigation-size-height-large: calc(4px * 2);
  --beacon-navigation-size-width-small-breakpoint-default: calc(4px + 2px);
  --beacon-navigation-size-width-small-breakpoint-medium: calc(4px - 2px);
  --beacon-navigation-size-width-medium-breakpoint-default: calc(8px * 3);
  --beacon-navigation-size-width-medium-breakpoint-medium: 16px;
  --beacon-navigation-size-width-large-breakpoint-default: 4px;
  --beacon-navigation-size-width-large-breakpoint-medium: calc(4px * 3);
  --beacon-navigation-size-width-x-large: calc(4px * 2);
  --beacon-navigation-space-bottom: calc(16px - 4px);
  --beacon-navigation-space-left: calc(55% - calc(16px + 8px));
  --beacon-navigation-space-margin-small: calc(4px - 2px);
  --beacon-navigation-space-margin-medium: calc(4px * 3);
  --beacon-navigation-space-margin-large: calc(4px + 2px);
  --beacon-navigation-space-margin-x-large: 16px;
  --beacon-navigation-space-padding-jumbo: calc(16px * 5.187);
  --beacon-navigation-space-padding-x-small: 8px;
  --beacon-navigation-space-padding-small: 4rem;
  --beacon-navigation-space-padding-medium: calc(16px - 4px);
  --beacon-navigation-space-padding-large: calc(16px - 6px);
  --beacon-navigation-space-padding-x-large: calc(16px - 1px);
  --beacon-navigation-space-padding-xx-large: calc(16px + 4px);
  --beacon-navigation-space-right: 8px;
  --beacon-navigation-space-top-x-small: calc(16px * 4px);
  --beacon-navigation-space-top-small-breakpoint-default: calc(16px * 1.6875);
  --beacon-navigation-space-top-small-breakpoint-medium: calc(16px - 4px);
  --beacon-navigation-space-top-medium: calc(16px + 6px);
  --beacon-navigation-space-top-large: calc(16px + 4px);
  --beacon-navigation-sub-heading-font-line-height: 1.43em;
  --beacon-navigation-sub-heading-font-size: 0.875rem;
  --beacon-popover-action-zone-space-margin: 0 0 0 calc(16px * 2);
  --beacon-popover-arrow-icon-down: no-repeat url("data:image/svg+xml;utf8,%3Csvg width='12' height='7' viewBox='0 0 12 7' fill='none' xmlns='http://www.w3.org/2000/svg' style='transform: rotate(180deg);'%3E%3Cpath d='M6 0.998535L12 6.99854L0 6.99854L6 0.998535Z' fill='%231E2D39'%3E%3C/path%3E%3C/svg%3E");
  --beacon-popover-arrow-icon-up: no-repeat url("data:image/svg+xml;utf8,%3Csvg width='12' height='7' viewBox='0 0 12 7' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M6 0.998535L12 6.99854L0 6.99854L6 0.998535Z' fill='%231E2D39'%3E%3C/path%3E%3C/svg%3E");
  --beacon-popover-arrow-size-height: 6px;
  --beacon-popover-arrow-size-width: 12px;
  --beacon-popover-arrow-space-margin: 24px;
  --beacon-popover-close-button-icon: no-repeat url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='40' height='40' viewBox='0 0 40 40'%3E%3Cpath d='M27 13L13 27' stroke='%23FFFFFF' stroke-width='1.5' stroke-linecap='round'/%3E%3Cpath d='M27 27L13 13' stroke='%23FFFFFF' stroke-width='1.5' stroke-linecap='round'/%3E%3C/svg%3E");
  --beacon-popover-close-button-size: 40px;
  --beacon-popover-color-background: rgba(30, 45, 57, 1);
  --beacon-popover-color-text: #d3d7da;
  --beacon-popover-content-size-width-breakpoint-default: 272px;
  --beacon-popover-content-size-width-breakpoint-medium: 292px;
  --beacon-popover-content-size-width-breakpoint-large: 292px;
  --beacon-popover-content-size-width-breakpoint-x-large: 348px;
  --beacon-popover-elevation: 0px 2px 4px -2px rgba(146, 155, 163, .8);
  --beacon-popover-font-line-height-breakpoint-default: 1.43;
  --beacon-popover-font-line-height-breakpoint-medium: 1.50;
  --beacon-popover-font-line-height-breakpoint-large: 1.50;
  --beacon-popover-font-line-height-breakpoint-x-large: 1.33;
  --beacon-popover-font-size-breakpoint-default: 0.875rem;
  --beacon-popover-font-size-breakpoint-medium: 1rem;
  --beacon-popover-font-size-breakpoint-large: 1rem;
  --beacon-popover-font-size-breakpoint-x-large: 1.125rem;
  --beacon-popover-size-border-radius: 4px;
  --beacon-popover-size-width-breakpoint-default: 288px;
  --beacon-popover-size-width-breakpoint-medium: 340px;
  --beacon-popover-size-width-breakpoint-large: 340px;
  --beacon-popover-size-width-breakpoint-x-large: 396px;
  --beacon-popover-space: 8px;
  --beacon-popover-surface-font-weight: 400;
  --beacon-popover-surface-space-padding: 8px 8px calc(8px*2) 8px;
  --beacon-popover-title-font-family: Nimbus Sans Novus Bold, Helvetica, Arial, sans-serif;
  --beacon-popover-title-font-weight: 700;
  --beacon-popover-title-size-width: 232px;
  --beacon-radio-button-check-mark-color-background-default-on-dark: #007db3;
  --beacon-radio-button-check-mark-color-background-default-on-light: #086ea1;
  --beacon-radio-button-check-mark-color-background-disabled-on-dark: #7c8790;
  --beacon-radio-button-check-mark-color-background-disabled-on-light: #929ba3;
  --beacon-radio-button-check-mark-size: 18px;
  --beacon-radio-button-check-mark-space-left: -31px;
  --beacon-radio-button-check-mark-space-top: 5px;
  --beacon-radio-button-color-background-disabled-on-dark: rgba(0, 0, 0, 0);
  --beacon-radio-button-color-border-default-on-dark: #bec3c8;
  --beacon-radio-button-color-border-default-on-light: #bec3c8;
  --beacon-radio-button-color-border-active-on-dark: #007db3;
  --beacon-radio-button-color-border-active-on-light: #086ea1;
  --beacon-radio-button-color-border-disabled-on-dark: #515f6b;
  --beacon-radio-button-color-border-disabled-on-light: #d3d7da;
  --beacon-radio-button-color-border-focus-on-dark: #ffffff;
  --beacon-radio-button-color-border-focus-on-light: #086ea1;
  --beacon-radio-button-color-text-default-on-dark: #d3d7da;
  --beacon-radio-button-color-text-default-on-light: #3b4b59;
  --beacon-radio-button-color-text-disabled-on-dark: #7c8790;
  --beacon-radio-button-color-text-disabled-on-light: #929ba3;
  --beacon-radio-button-font-line-height-breakpoint-default: 1.43;
  --beacon-radio-button-font-line-height-breakpoint-medium: 1.50;
  --beacon-radio-button-font-line-height-breakpoint-large: 1.50;
  --beacon-radio-button-font-line-height-breakpoint-x-large: 1.56;
  --beacon-radio-button-font-size-breakpoint-default: 0.875rem;
  --beacon-radio-button-font-size-breakpoint-medium: 1rem;
  --beacon-radio-button-font-size-breakpoint-large: 1rem;
  --beacon-radio-button-font-size-breakpoint-x-large: 1.125rem;
  --beacon-radio-button-hint-text-font-weight: 400;
  --beacon-radio-button-hint-text-space-margin: 0 0 4px 0;
  --beacon-radio-button-label-color-background: #ffffff;
  --beacon-radio-button-label-font-family-active: Nimbus Sans Novus Bold, Helvetica, Arial, sans-serif;
  --beacon-radio-button-label-space-left: value;
  --beacon-radio-button-label-space-margin: 6px 0 0 0;
  --beacon-radio-button-size-border-radius: 50%;
  --beacon-radio-button-size-height-default: 28px;
  --beacon-radio-button-size-height-focus: 34px;
  --beacon-radio-button-size-width-default: 28px;
  --beacon-radio-button-size-width-focus: 34px;
  --beacon-radio-button-space-left-default: -36px;
  --beacon-radio-button-space-left-focus: -39px;
  --beacon-radio-button-space-margin-default: 10px 0 10px 1rem;
  --beacon-radio-button-space-margin-first-child: 0 0 10px 1rem;
  --beacon-radio-button-space-margin-last-child: 10px 0 0 1rem;
  --beacon-radio-button-space-top: -3px;
  --beacon-radio-button-title-font-family: Nimbus Sans Novus Bold, Helvetica, Arial, sans-serif;
  --beacon-radio-button-title-font-line-height-breakpoint-default: 1.50;
  --beacon-radio-button-title-font-line-height-breakpoint-medium: 1.56;
  --beacon-radio-button-title-font-line-height-breakpoint-large: 1.56;
  --beacon-radio-button-title-font-line-height-breakpoint-x-large: 1.60;
  --beacon-radio-button-title-font-size-breakpoint-default: 1rem;
  --beacon-radio-button-title-font-size-breakpoint-medium: 1.125rem;
  --beacon-radio-button-title-font-size-breakpoint-large: 1.125rem;
  --beacon-radio-button-title-font-size-breakpoint-x-large: 1.25rem;
  --beacon-site-selector-check-button-icon: no-repeat url("data:image/svg+xml,%3Csvg width='15' height='13' viewBox='0 0 15 13' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M1 7.51852L5.78947 12L14 1' stroke='%23248647' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E%0A");
  --beacon-site-selector-color-background-primary: #ffffff;
  --beacon-site-selector-color-background-secondary: #f4f5f6;
  --beacon-site-selector-color-border: #e9ebed;
  --beacon-site-selector-color-link-primary: #086ea1;
  --beacon-site-selector-color-link-secondary: #ffffff;
  --beacon-site-selector-color-text: #3b4b59;
  --beacon-site-selector-duration-ease: ease;
  --beacon-site-selector-duration-ease-out: ease-out;
  --beacon-site-selector-duration-half-second: .5s;
  --beacon-site-selector-duration-quarter-second: .25s;
  --beacon-site-selector-elevation: 0px 16px 24px -16px rgba(0, 47, 72, .56);
  --beacon-site-selector-font-family-default: Nimbus Sans Novus Regular, Helvetica, Arial, sans-serif;
  --beacon-site-selector-font-family-bold: Nimbus Sans Novus Bold, Helvetica, Arial, sans-serif;
  --beacon-site-selector-font-line-height-large: 1.43;
  --beacon-site-selector-font-line-height-x-large: 1.50;
  --beacon-site-selector-font-size-small: 0.875rem;
  --beacon-site-selector-font-size-medium: 1.125rem;
  --beacon-site-selector-font-size-large: 1rem;
  --beacon-site-selector-size-border-small: 1px;
  --beacon-site-selector-size-border-large: 10px;
  --beacon-site-selector-size-border-radius: 4px;
  --beacon-site-selector-size-height-breakpoint-default: 12px;
  --beacon-site-selector-size-height-breakpoint-medium: 16px;
  --beacon-site-selector-size-width-breakpoint-default: 24px;
  --beacon-site-selector-size-width-breakpoint-medium: 400px;
  --beacon-site-selector-space-left: 49%;
  --beacon-site-selector-space-margin: calc(4px * 6);
  --beacon-site-selector-space-padding-xx-small: 4px;
  --beacon-site-selector-space-padding-x-small: 38px;
  --beacon-site-selector-space-padding-small: calc(4px * 2.5);
  --beacon-site-selector-space-padding-medium: calc(16px * 1.5);
  --beacon-site-selector-space-padding-x-large: calc(16px * 1.375);
  --beacon-site-selector-space-top-small: calc(4px - 14px);
  --beacon-site-selector-space-top-medium: calc(4px - 1px);
  --beacon-stepper-button-color-background-inactive-on-dark: #66737e;
  --beacon-stepper-button-color-background-inactive-on-light: #929ba3;
  --beacon-stepper-button-color-background-primary-on-dark: #007db3;
  --beacon-stepper-button-color-background-primary-on-light: #086ea1;
  --beacon-stepper-button-color-background-secondary-on-dark: #ffffff;
  --beacon-stepper-button-size: 40px;
  --beacon-stepper-button-space-padding: 4px;
  --beacon-stepper-icon-color-background-inactive: #a8afb5;
  --beacon-stepper-icon-color-background-primary: #ffffff;
  --beacon-stepper-icon-color-background-secondary: #7c8790;
  --beacon-stepper-icon-size-border-radius: calc(2*16px);
  --beacon-stepper-icon-size-height-primary: calc(2*16px);
  --beacon-stepper-icon-size-height-secondary: 30px;
  --beacon-stepper-icon-size-line-length: 10px;
  --beacon-stepper-icon-size-line-radius: 2px;
  --beacon-stepper-icon-size-width-primary: calc(2*16px);
  --beacon-stepper-icon-size-width-secondary: 30px;
  --beacon-stepper-input-border-active: 1px solid #bec3c8;
  --beacon-stepper-input-border-inactive: 1px solid #d3d7da;
  --beacon-stepper-input-color-background: #ffffff;
  --beacon-stepper-input-color-border-active: #bec3c8;
  --beacon-stepper-input-color-border-inactive-on-dark: #515f6b;
  --beacon-stepper-input-color-border-inactive-on-light: #d3d7da;
  --beacon-stepper-input-size-border-radius: 4px;
  --beacon-stepper-input-size-height: 40px;
  --beacon-stepper-input-size-width: 35px;
  --beacon-stepper-input-space-margin: 0 8px;
  --beacon-sticky-navigation-active-color-background-breakpoint-medium: #054c70;
  --beacon-sticky-navigation-active-color-background-breakpoint-x-large: #ffffff;
  --beacon-sticky-navigation-active-color-text-breakpoint-medium: #ffffff;
  --beacon-sticky-navigation-active-color-text-breakpoint-x-large: #3b4b59;
  --beacon-sticky-navigation-active-font-family-bold: Nimbus Sans Novus Bold, Helvetica, Arial, sans-serif;
  --beacon-sticky-navigation-active-font-size-breakpoint-medium: 0.875rem;
  --beacon-sticky-navigation-active-font-size-breakpoint-large: 1rem;
  --beacon-sticky-navigation-font-family-bold: Nimbus Sans Novus Bold, Helvetica, Arial, sans-serif;
  --beacon-sticky-navigation-font-family-regular: Nimbus Sans Novus Regular, Helvetica, Arial, sans-serif;
  --beacon-sticky-navigation-label-icon-color-background: #086ea1;
  --beacon-sticky-navigation-label-icon-space-height: calc(16px * 3);
  --beacon-sticky-navigation-label-icon-space-width: calc(16px * 3);
  --beacon-sticky-navigation-scroll-to-anchor-color-background-default: #086ea1;
  --beacon-sticky-navigation-scroll-to-anchor-color-background-hover: #07608d;
  --beacon-sticky-navigation-scroll-to-anchor-color-hover: #ffffff;
  --beacon-sticky-navigation-scroll-to-anchor-color-text: #ffffff;
  --beacon-sticky-navigation-scroll-to-anchor-font-size-breakpoint-medium: 0.875rem;
  --beacon-sticky-navigation-scroll-to-anchor-font-size-breakpoint-large: 1rem;
  --beacon-sticky-navigation-scroll-to-anchor-font-text-align: center;
  --beacon-sticky-navigation-scroll-to-anchor-opacity-hover: 0.8;
  --beacon-sticky-navigation-scroll-to-anchor-space-min-height-breakpoint-large: calc(16px * 4);
  --beacon-sticky-navigation-scroll-to-anchor-space-padding-horizontal-breakpoint-default: calc(16px + 2px);
  --beacon-sticky-navigation-scroll-to-anchor-space-padding-horizontal-breakpoint-large: 16px;
  --beacon-sticky-navigation-scroll-to-anchor-space-padding-vertical: calc(8px);
  --beacon-sticky-navigation-scroll-to-anchor-transition-hover: opacity 0.3s;
  --beacon-sticky-navigation-sticky-arrow-icon-color-border: #ffffff;
  --beacon-sticky-navigation-sticky-arrow-icon-space-border: 1.5px solid;
  --beacon-sticky-navigation-sticky-arrow-icon-space-border-width: 1.5px;
  --beacon-sticky-navigation-sticky-arrow-icon-space-height: 5px;
  --beacon-sticky-navigation-sticky-arrow-icon-space-width: 5px;
  --beacon-sticky-navigation-sticky-arrow-icon-transition: transform .25s linear;
  --beacon-sticky-navigation-sticky-arrow-icon-collapsed-layout: rotate(45deg);
  --beacon-sticky-navigation-sticky-arrow-icon-expanded-layout: rotate(225deg);
  --beacon-sticky-navigation-sticky-band-color-background-breakpoint-large: #f9fafa;
  --beacon-sticky-navigation-sticky-band-space-height-breakpoint-large: 100%;
  --beacon-sticky-navigation-sticky-band-space-width-breakpoint-large: 100vw;
  --beacon-sticky-navigation-sticky-inner-color-background: #ffffff;
  --beacon-sticky-navigation-sticky-inner-space-left: 99;
  --beacon-sticky-navigation-sticky-inner-space-padding-bottom: 40px;
  --beacon-sticky-navigation-sticky-inner-space-right: 100%;
  --beacon-sticky-navigation-sticky-inner-space-top: calc(16px * 3);
  --beacon-sticky-navigation-sticky-item-color-background: #f9fafa;
  --beacon-sticky-navigation-sticky-item-z-index: 1;
  --beacon-sticky-navigation-sticky-item-heading-color: #ffffff;
  --beacon-sticky-navigation-sticky-item-heading-font-size: calc(16px - 2px);
  --beacon-sticky-navigation-sticky-item-heading-font-text-align: center;
  --beacon-sticky-navigation-sticky-item-heading-font-weight: bold;
  --beacon-sticky-navigation-sticky-item-heading-space-margin-top: 90px;
  --beacon-sticky-navigation-sticky-item-heading-space-padding: 18px 8px;
  --beacon-sticky-navigation-sticky-item-heading-space-width: 100%;
  --beacon-sticky-navigation-sticky-label-section-color-background: #f4f5f6;
  --beacon-sticky-navigation-sticky-label-section-color-text: #3b4b59;
  --beacon-sticky-navigation-sticky-label-section-font-normal: 0.875rem;
  --beacon-sticky-navigation-sticky-label-section-space-line-height: calc(16px + 4px);
  --beacon-sticky-navigation-sticky-label-section-space-width: 100%;
  --beacon-sticky-navigation-text-label-layout-flex-grow: 1;
  --beacon-sticky-navigation-text-label-space-padding: calc(16px - 2px);
  --beacon-table-color-background-primary: #ebebeb;
  --beacon-table-color-background-secondary: #f5f5f5;
  --beacon-table-color-border-primary: #ffffff;
  --beacon-table-color-border-secondary: #ababab;
  --beacon-table-font-size: 0.875rem;
  --beacon-text-area-color-border-on-dark: #bec3c8;
  --beacon-text-area-color-border-on-light: #bec3c8;
  --beacon-text-area-color-caret: #05c3de;
  --beacon-text-area-color-text-default-on-dark: #3b4b59;
  --beacon-text-area-color-text-default-on-light: #3b4b59;
  --beacon-text-area-color-text-disabled-on-dark: #929ba3;
  --beacon-text-area-color-text-disabled-on-light: #929ba3;
  --beacon-text-area-font-line-height-breakpoint-default: 1.43;
  --beacon-text-area-font-line-height-breakpoint-medium: 1.50;
  --beacon-text-area-font-line-height-breakpoint-large: 1.50;
  --beacon-text-area-font-line-height-breakpoint-x-large: 1.56;
  --beacon-text-area-font-size-breakpoint-default: 0.875rem;
  --beacon-text-area-font-size-breakpoint-medium: 1rem;
  --beacon-text-area-font-size-breakpoint-large: 1rem;
  --beacon-text-area-font-size-breakpoint-x-large: 1.125rem;
  --beacon-text-area-size-border-radius: 4px;
  --beacon-text-area-size-border-width-default: 1px;
  --beacon-text-area-size-height-breakpoint-default: 124px;
  --beacon-text-area-size-height-breakpoint-medium: 140px;
  --beacon-text-area-size-height-breakpoint-large: 140px;
  --beacon-text-area-size-height-breakpoint-x-large: 144px;
  --beacon-text-area-size-max-height: 100%;
  --beacon-text-area-size-max-width: 100%;
  --beacon-text-area-size-width: 400px;
  --beacon-text-area-space-margin: 4px 0px 0px 0px;
  --beacon-text-area-space-padding: calc(4px + 8px);
  --beacon-toggle-button-border: 1px solid #d3d7da;
  --beacon-toggle-button-color-background: #ffffff;
  --beacon-toggle-button-color-border: #d3d7da;
  --beacon-toggle-button-label-color-text-default: #086ea1;
  --beacon-toggle-button-label-color-text-focus: #ffffff;
  --beacon-toggle-button-label-font-family: Nimbus Sans Novus Bold, Helvetica, Arial, sans-serif;
  --beacon-toggle-button-label-font-line-height-mini-breakpoint-default: 1.33;
  --beacon-toggle-button-label-font-line-height-mini-breakpoint-medium: 1.43;
  --beacon-toggle-button-label-font-line-height-mini-breakpoint-x-large: 1.50;
  --beacon-toggle-button-label-font-line-height-normal-breakpoint-default: 1.43;
  --beacon-toggle-button-label-font-line-height-normal-breakpoint-medium: 1.50;
  --beacon-toggle-button-label-font-line-height-normal-breakpoint-x-large: 1.56;
  --beacon-toggle-button-label-font-size-mini-breakpoint-default: 0.75rem;
  --beacon-toggle-button-label-font-size-mini-breakpoint-medium: 0.875rem;
  --beacon-toggle-button-label-font-size-mini-breakpoint-x-large: 1rem;
  --beacon-toggle-button-label-font-size-normal-breakpoint-default: 0.875rem;
  --beacon-toggle-button-label-font-size-normal-breakpoint-medium: 1rem;
  --beacon-toggle-button-label-font-size-normal-breakpoint-x-large: 1.125rem;
  --beacon-toggle-button-label-size-height-mini-breakpoint-default: 24px;
  --beacon-toggle-button-label-size-height-mini-breakpoint-medium: 28px;
  --beacon-toggle-button-label-size-height-mini-breakpoint-x-large: 32px;
  --beacon-toggle-button-label-size-height-normal-breakpoint-default: 36px;
  --beacon-toggle-button-label-size-height-normal-breakpoint-medium: 40px;
  --beacon-toggle-button-label-space-padding-breakpoint-default: 0 8px;
  --beacon-toggle-button-label-space-padding-breakpoint-medium: 0 12px;
  --beacon-toggle-button-size-border-radius: 45px;
  --beacon-toggle-button-slider-color-background: #086ea1;
  --beacon-toggle-button-slider-duration: .25s;
  --beacon-toggle-button-slider-size-border-radius: 32px;
  --beacon-toggle-button-slider-size-height: calc(100% - 6px);
  --beacon-toggle-button-slider-space-margin-left: 4px;
  --beacon-toggle-button-slider-space-margin-top: -1px;
  --beacon-toggle-button-space-padding: 3px;
  --beacon-toggle-switch-label-space-width: 100%;
  --beacon-toggle-switch-slider-color-background-default: rgba(249, 250, 250, 1);
  --beacon-toggle-switch-slider-color-background-active-on-dark: rgba(0, 125, 179, 1);
  --beacon-toggle-switch-slider-color-background-active-on-light: rgba(8, 110, 161, 1);
  --beacon-toggle-switch-slider-color-background-inactive: rgba(211, 215, 218, 1);
  --beacon-toggle-switch-slider-color-border-default: rgba(211, 215, 218, 1);
  --beacon-toggle-switch-slider-color-border-active-on-dark: rgba(0, 125, 179, 1);
  --beacon-toggle-switch-slider-color-border-active-on-light: rgba(8, 110, 161, 1);
  --beacon-toggle-switch-slider-color-border-inactive: rgba(211, 215, 218, 1);
  --beacon-toggle-switch-slider-color-text-default: rgba(146, 155, 163, 1);
  --beacon-toggle-switch-slider-color-text-active: rgba(255, 255, 255, 1);
  --beacon-toggle-switch-slider-color-text-inactive: rgba(211, 215, 218, 1);
  --beacon-toggle-switch-slider-duration: .25s;
  --beacon-toggle-switch-slider-font-family: Nimbus Sans Novus Bold, Helvetica, Arial, sans-serif;
  --beacon-toggle-switch-slider-font-height: 25px;
  --beacon-toggle-switch-slider-font-letter-spacing: 0.0012em;
  --beacon-toggle-switch-slider-font-line-height: 1.33em;
  --beacon-toggle-switch-slider-font-size: 0.75rem;
  --beacon-toggle-switch-slider-font-width-default: 17px;
  --beacon-toggle-switch-slider-font-width-active: 18px;
  --beacon-toggle-switch-slider-space-height: 28px;
  --beacon-toggle-switch-slider-space-icon-left-default: 29px;
  --beacon-toggle-switch-slider-space-icon-left-active: 9px;
  --beacon-toggle-switch-slider-space-icon-top: 5px;
  --beacon-toggle-switch-slider-space-text-left-default: 29px;
  --beacon-toggle-switch-slider-space-text-left-active: 9px;
  --beacon-toggle-switch-slider-space-width: 56px;
  --beacon-toggle-switch-switch-color-background-active: rgba(255, 255, 255, 1);
  --beacon-toggle-switch-switch-color-background-inactive: rgba(211, 215, 218, 1);
  --beacon-toggle-switch-switch-elevation-active: 0 2px 2px 0 rgba(0, 0, 0, 0.08), 2px 3px 7px 0 rgba(0, 0, 0, 0.16);
  --beacon-toggle-switch-switch-elevation-inactive: none;
  --beacon-toggle-switch-switch-size-border-radius: 50%;
  --beacon-toggle-switch-switch-size-height: 22px;
  --beacon-toggle-switch-switch-size-width: 22px;
  --beacon-toggle-switch-switch-space-bottom: 2px;
  --beacon-toggle-switch-switch-space-left-default: 2px;
  --beacon-toggle-switch-switch-space-left-active: 30px;
  --beacon-tooltip-arrow-icon-down: no-repeat url("data:image/svg+xml;utf8,%3Csvg width='12' height='7' viewBox='0 0 12 7' fill='none' xmlns='http://www.w3.org/2000/svg' style='transform: rotate(180deg);'%3E%3Cpath d='M6 0.998535L12 6.99854L0 6.99854L6 0.998535Z' fill='%231E2D39'%3E%3C/path%3E%3C/svg%3E");
  --beacon-tooltip-arrow-icon-left: no-repeat url("data:image/svg+xml,%3Csvg width='6' height='12' viewBox='0 0 6 12' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M-0.000975776 6L5.99903 7.86805e-07L5.99902 12L-0.000975776 6Z' fill='%231E2D39'/%3E%3C/svg%3E%0A");
  --beacon-tooltip-arrow-icon-right: no-repeat url("data:image/svg+xml,%3Csvg width='6' height='12' viewBox='0 0 6 12' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M6 6L0 12L0 0L6 6Z' fill='%231E2D39'/%3E%3C/svg%3E%0A");
  --beacon-tooltip-arrow-icon-up: no-repeat url("data:image/svg+xml;utf8,%3Csvg width='12' height='7' viewBox='0 0 12 7' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M6 0.998535L12 6.99854L0 6.99854L6 0.998535Z' fill='%231E2D39'%3E%3C/path%3E%3C/svg%3E");
  --beacon-tooltip-arrow-size-height: 6px;
  --beacon-tooltip-arrow-size-width: 12px;
  --beacon-tooltip-arrow-space-margin-default: 8px;
  --beacon-tooltip-arrow-space-margin-side: 15px 0 0 0;
  --beacon-tooltip-color-background: rgba(30, 45, 57, 1);
  --beacon-tooltip-color-text: #d3d7da;
  --beacon-tooltip-elevation: 0px 2px 4px -2px rgba(146, 155, 163, .8);
  --beacon-tooltip-size-border-radius: 4px;
  --beacon-tooltip-surface-space-margin: 0.125rem 0 0 0;
  --beacon-tooltip-surface-space-padding: 8px 12px;
  --beacon-tooltip-title-font-family: Nimbus Sans Novus Bold, Helvetica, Arial, sans-serif;
  --beacon-tooltip-title-font-line-height: 1.33;
  --beacon-tooltip-title-font-size: 1.125rem;
  --beacon-tooltip-title-font-weight: 700;
  --beacon-tooltip-title-space-margin: 8px 8px 0px 8px;
  --beacon-tooltip-title-space-padding: 8px;
  --beacon-border-width-small: 1px;
  --beacon-border-width-medium: 3px;
  --beacon-border-width-large: 10px;
  --beacon-breakpoint-small: 320px;
  --beacon-breakpoint-medium: 640px;
  --beacon-breakpoint-large: 960px;
  --beacon-breakpoint-x-large: 1280px;
  --beacon-breakpoint-xx-large: 1600px;
  --beacon-color-background-default: #ffffff;
  --beacon-color-background-dark-blue: #054c70;
  --beacon-color-background-dark-grey: #1e2d39;
  --beacon-color-background-light-grey: #f4f5f6;
  --beacon-color-background-light-grey-2: #f9fafa;
  --beacon-color-background-medium-grey-2: #7c8790;
  --beacon-color-background-medium-grey-4: #a8afb5;
  --beacon-color-background-midnight-blue: #002f48;
  --beacon-color-border-default-on-dark: #515f6b;
  --beacon-color-border-default-on-light: #bec3c8;
  --beacon-color-border-disabled-on-dark: #515f6b;
  --beacon-color-border-disabled-on-light: #d3d7da;
  --beacon-color-border-focus-on-dark: #ffffff;
  --beacon-color-border-focus-on-light: #086ea1;
  --beacon-color-border-light-blue: #086ea1;
  --beacon-color-border-light-grey: #e9ebed;
  --beacon-color-border-light-grey-2: #d3d7da;
  --beacon-color-cta-negative-default: #dd3636;
  --beacon-color-cta-negative-disabled-on-dark: #66737e;
  --beacon-color-cta-negative-disabled-on-light: #929ba3;
  --beacon-color-cta-negative-hover: #da2525;
  --beacon-color-cta-negative-pressed: #c92222;
  --beacon-color-cta-positive-default: #248647;
  --beacon-color-cta-positive-disabled-on-dark: #66737e;
  --beacon-color-cta-positive-disabled-on-light: #929ba3;
  --beacon-color-cta-positive-hover: #1f753e;
  --beacon-color-cta-positive-pressed: #1b6435;
  --beacon-color-cta-primary-default-on-dark: #007db3;
  --beacon-color-cta-primary-default-on-light: #086ea1;
  --beacon-color-cta-primary-disabled-on-dark: #66737e;
  --beacon-color-cta-primary-disabled-on-light: #929ba3;
  --beacon-color-cta-primary-error-on-dark: #dd3636;
  --beacon-color-cta-primary-error-on-light: #dd3636;
  --beacon-color-cta-primary-focus-on-dark: #ffffff;
  --beacon-color-cta-primary-focus-on-light: #086ea1;
  --beacon-color-cta-primary-hover-on-dark: #006e9e;
  --beacon-color-cta-primary-hover-on-light: #07608d;
  --beacon-color-cta-primary-pressed-on-dark: #00608a;
  --beacon-color-cta-primary-pressed-on-light: #065379;
  --beacon-color-cta-secondary-default: #ffffff;
  --beacon-color-cta-secondary-disabled-on-dark: #7c8790;
  --beacon-color-cta-secondary-disabled-on-light: #929ba3;
  --beacon-color-shadow-on-dark: rgba(0, 47, 72, 1);
  --beacon-color-shadow-on-light: rgba(146, 155, 163, 1);
  --beacon-color-text-default-on-dark: #d3d7da;
  --beacon-color-text-default-on-light: #3b4b59;
  --beacon-color-text-disabled-on-light: #929ba3;
  --beacon-color-text-hyperlink-default-on-dark: #ffffff;
  --beacon-color-text-hyperlink-default-on-light: #086ea1;
  --beacon-color-text-hyperlink-visited-on-dark: #ffffff;
  --beacon-color-text-hyperlink-visited-on-light: #086ea1;
  --beacon-elevation-bottom-level-0-on-dark: 0px 2px 0px -1px rgba(0, 47, 72, .4);
  --beacon-elevation-bottom-level-0-on-light: 0px 2px 0px -1px rgba(146, 155, 163, .4);
  --beacon-elevation-bottom-level-1-on-dark: 0px 2px 4px -2px rgba(0, 47, 72, .8);
  --beacon-elevation-bottom-level-1-on-light: 0px 2px 4px -2px rgba(146, 155, 163, .8);
  --beacon-elevation-bottom-level-2-on-dark: 0px 8px 12px -8px rgba(0, 47, 72, .64);
  --beacon-elevation-bottom-level-2-on-light: 0px 8px 12px -8px rgba(146, 155, 163, .64);
  --beacon-elevation-bottom-level-3-on-dark: 0px 16px 24px -16px rgba(0, 47, 72, .56);
  --beacon-elevation-bottom-level-3-on-light: 0px 16px 24px -16px rgba(146, 155, 163, .48);
  --beacon-elevation-top-level-0-on-dark: 0px -2px 0px -1px rgba(0, 47, 72, .4);
  --beacon-elevation-top-level-0-on-light: 0px -2px 0px -1px rgba(146, 155, 163, .4);
  --beacon-elevation-top-level-1-on-dark: 0px -2px 4px -2px rgba(0, 47, 72, .8);
  --beacon-elevation-top-level-1-on-light: 0px -2px 4px -2px rgba(146, 155, 163, .8);
  --beacon-elevation-top-level-2-on-dark: 0px -8px 12px -8px rgba(0, 47, 72, .64);
  --beacon-elevation-top-level-2-on-light: 0px -8px 12px -8px rgba(146, 155, 163, .64);
  --beacon-elevation-top-level-3-on-dark: 0px -16px 24px -16px rgba(0, 47, 72, .56);
  --beacon-elevation-top-level-3-on-light: 0px -16px 24px -16px rgba(146, 155, 163, .48);
  --beacon-body-font-line-height-long-form-normal-breakpoint-default: 1.56;
  --beacon-body-font-line-height-long-form-normal-breakpoint-medium: 1.60;
  --beacon-body-font-line-height-long-form-normal-breakpoint-large: 1.60;
  --beacon-body-font-line-height-long-form-normal-breakpoint-x-large: 1.33;
  --beacon-body-font-line-height-long-form-small-breakpoint-default: 1.50;
  --beacon-body-font-line-height-long-form-small-breakpoint-medium: 1.56;
  --beacon-body-font-line-height-long-form-small-breakpoint-large: 1.56;
  --beacon-body-font-line-height-long-form-small-breakpoint-x-large: 1.60;
  --beacon-body-font-line-height-module-normal-breakpoint-default: 1.33;
  --beacon-body-font-line-height-module-normal-breakpoint-medium: 1.40;
  --beacon-body-font-line-height-module-normal-breakpoint-large: 1.40;
  --beacon-body-font-line-height-module-normal-breakpoint-x-large: 1.33;
  --beacon-body-font-line-height-module-small-breakpoint-default: 1.50;
  --beacon-body-font-line-height-module-small-breakpoint-medium: 1.33;
  --beacon-body-font-line-height-module-small-breakpoint-large: 1.33;
  --beacon-body-font-line-height-module-small-breakpoint-x-large: 1.40;
  --beacon-body-font-size-normal-breakpoint-default: 1.125rem;
  --beacon-body-font-size-normal-breakpoint-medium: 1.25rem;
  --beacon-body-font-size-normal-breakpoint-large: 1.25rem;
  --beacon-body-font-size-normal-breakpoint-x-large: 1.5rem;
  --beacon-body-font-size-small-breakpoint-default: 1rem;
  --beacon-body-font-size-small-breakpoint-medium: 1.125rem;
  --beacon-body-font-size-small-breakpoint-large: 1.125rem;
  --beacon-body-font-size-small-breakpoint-x-large: 1.25rem;
  --beacon-caption-font-line-height-long-form-normal-breakpoint-default: 1.33;
  --beacon-caption-font-line-height-long-form-normal-breakpoint-medium: 1.43;
  --beacon-caption-font-line-height-long-form-normal-breakpoint-large: 1.43;
  --beacon-caption-font-line-height-long-form-normal-breakpoint-x-large: 1.50;
  --beacon-caption-font-line-height-long-form-x-small-breakpoint-default: 1.60;
  --beacon-caption-font-line-height-long-form-x-small-breakpoint-x-large: 1.33;
  --beacon-caption-font-line-height-long-form-small-breakpoint-default: 1.60;
  --beacon-caption-font-line-height-long-form-small-breakpoint-medium: 1.33;
  --beacon-caption-font-line-height-long-form-small-breakpoint-large: 1.33;
  --beacon-caption-font-line-height-long-form-small-breakpoint-x-large: 1.43;
  --beacon-caption-font-line-height-module-normal-breakpoint-default: 1.33;
  --beacon-caption-font-line-height-module-normal-breakpoint-medium: 1.43;
  --beacon-caption-font-line-height-module-normal-breakpoint-large: 1.43;
  --beacon-caption-font-line-height-module-normal-breakpoint-x-large: 1.50;
  --beacon-caption-font-line-height-module-x-small-breakpoint-default: 1.60;
  --beacon-caption-font-line-height-module-x-small-breakpoint-x-large: 1.33;
  --beacon-caption-font-line-height-module-small-breakpoint-default: 1.60;
  --beacon-caption-font-line-height-module-small-breakpoint-medium: 1.33;
  --beacon-caption-font-line-height-module-small-breakpoint-large: 1.33;
  --beacon-caption-font-line-height-module-small-breakpoint-x-large: 1.43;
  --beacon-caption-font-size-normal-breakpoint-default: 0.75rem;
  --beacon-caption-font-size-normal-breakpoint-medium: 0.875rem;
  --beacon-caption-font-size-normal-breakpoint-large: 0.875rem;
  --beacon-caption-font-size-normal-breakpoint-x-large: 1rem;
  --beacon-caption-font-size-x-small: 0.625rem;
  --beacon-caption-font-size-small-breakpoint-default: 0.625rem;
  --beacon-caption-font-size-small-breakpoint-medium: 0.75rem;
  --beacon-caption-font-size-small-breakpoint-large: 0.75rem;
  --beacon-caption-font-size-small-breakpoint-x-large: 0.875rem;
  --beacon-h1-font-line-height-long-form-breakpoint-default: 1.20;
  --beacon-h1-font-line-height-long-form-breakpoint-medium: 1.17;
  --beacon-h1-font-line-height-long-form-breakpoint-large: 1.17;
  --beacon-h1-font-line-height-long-form-breakpoint-x-large: 1.14;
  --beacon-h1-font-line-height-module-breakpoint-default: 1.20;
  --beacon-h1-font-line-height-module-breakpoint-medium: 1.17;
  --beacon-h1-font-line-height-module-breakpoint-large: 1.17;
  --beacon-h1-font-line-height-module-breakpoint-x-large: 1.14;
  --beacon-h1-font-size-breakpoint-default: 2.5rem;
  --beacon-h1-font-size-breakpoint-medium: 3rem;
  --beacon-h1-font-size-breakpoint-large: 3rem;
  --beacon-h1-font-size-breakpoint-x-large: 3.5rem;
  --beacon-h2-font-line-height-long-form-breakpoint-default: 1.38;
  --beacon-h2-font-line-height-long-form-breakpoint-medium: 1.33;
  --beacon-h2-font-line-height-long-form-breakpoint-large: 1.33;
  --beacon-h2-font-line-height-long-form-breakpoint-x-large: 1.20;
  --beacon-h2-font-line-height-module-breakpoint-default: 1.25;
  --beacon-h2-font-line-height-module-breakpoint-medium: 1.22;
  --beacon-h2-font-line-height-module-breakpoint-large: 1.22;
  --beacon-h2-font-line-height-module-breakpoint-x-large: 1.20;
  --beacon-h2-font-size-breakpoint-default: 2rem;
  --beacon-h2-font-size-breakpoint-medium: 2.25rem;
  --beacon-h2-font-size-breakpoint-large: 2.25rem;
  --beacon-h2-font-size-breakpoint-x-large: 2.5rem;
  --beacon-h3-font-line-height-long-form-breakpoint-default: 1.43;
  --beacon-h3-font-line-height-long-form-breakpoint-medium: 1.38;
  --beacon-h3-font-line-height-long-form-breakpoint-large: 1.38;
  --beacon-h3-font-line-height-long-form-breakpoint-x-large: 1.33;
  --beacon-h3-font-line-height-module-breakpoint-default: 1.29;
  --beacon-h3-font-line-height-module-breakpoint-medium: 1.25;
  --beacon-h3-font-line-height-module-breakpoint-large: 1.25;
  --beacon-h3-font-line-height-module-breakpoint-x-large: 1.22;
  --beacon-h3-font-size-breakpoint-default: 1.75rem;
  --beacon-h3-font-size-breakpoint-medium: 2rem;
  --beacon-h3-font-size-breakpoint-large: 2rem;
  --beacon-h3-font-size-breakpoint-x-large: 2.25rem;
  --beacon-h4-font-line-height-long-form-breakpoint-default: 1.33;
  --beacon-h4-font-line-height-long-form-breakpoint-medium: 1.43;
  --beacon-h4-font-line-height-long-form-breakpoint-large: 1.43;
  --beacon-h4-font-line-height-long-form-breakpoint-x-large: 1.38;
  --beacon-h4-font-line-height-module-breakpoint-default: 1.33;
  --beacon-h4-font-line-height-module-breakpoint-medium: 1.29;
  --beacon-h4-font-line-height-module-breakpoint-large: 1.29;
  --beacon-h4-font-line-height-module-breakpoint-x-large: 1.25;
  --beacon-h4-font-size-breakpoint-default: 1.5rem;
  --beacon-h4-font-size-breakpoint-medium: 1.75rem;
  --beacon-h4-font-size-breakpoint-large: 1.75rem;
  --beacon-h4-font-size-breakpoint-x-large: 2rem;
  --beacon-h5-font-line-height-long-form-breakpoint-default: 1.60;
  --beacon-h5-font-line-height-long-form-breakpoint-medium: 1.33;
  --beacon-h5-font-line-height-long-form-breakpoint-large: 1.33;
  --beacon-h5-font-line-height-long-form-breakpoint-x-large: 1.43;
  --beacon-h5-font-line-height-module-breakpoint-default: 1.40;
  --beacon-h5-font-line-height-module-breakpoint-medium: 1.33;
  --beacon-h5-font-line-height-module-breakpoint-large: 1.33;
  --beacon-h5-font-line-height-module-breakpoint-x-large: 1.29;
  --beacon-h5-font-size-breakpoint-default: 1.25rem;
  --beacon-h5-font-size-breakpoint-medium: 1.5rem;
  --beacon-h5-font-size-breakpoint-large: 1.5rem;
  --beacon-h5-font-size-breakpoint-x-large: 1.75rem;
  --beacon-h6-font-line-height-long-form-breakpoint-default: 1.50;
  --beacon-h6-font-line-height-long-form-breakpoint-medium: 1.56;
  --beacon-h6-font-line-height-long-form-breakpoint-large: 1.56;
  --beacon-h6-font-line-height-long-form-breakpoint-x-large: 1.60;
  --beacon-h6-font-line-height-module-breakpoint-default: 1.50;
  --beacon-h6-font-line-height-module-breakpoint-medium: 1.33;
  --beacon-h6-font-line-height-module-breakpoint-large: 1.33;
  --beacon-h6-font-line-height-module-breakpoint-x-large: 1.40;
  --beacon-h6-font-size-breakpoint-default: 1rem;
  --beacon-h6-font-size-breakpoint-medium: 1.125rem;
  --beacon-h6-font-size-breakpoint-large: 1.125rem;
  --beacon-h6-font-size-breakpoint-x-large: 1.25rem;
  --beacon-h7-font-line-height-long-form-breakpoint-default: 1.43;
  --beacon-h7-font-line-height-long-form-breakpoint-medium: 1.50;
  --beacon-h7-font-line-height-long-form-breakpoint-large: 1.50;
  --beacon-h7-font-line-height-long-form-breakpoint-x-large: 1.56;
  --beacon-h7-font-line-height-module-breakpoint-default: 1.43;
  --beacon-h7-font-line-height-module-breakpoint-medium: 1.50;
  --beacon-h7-font-line-height-module-breakpoint-large: 1.50;
  --beacon-h7-font-line-height-module-breakpoint-x-large: 1.33;
  --beacon-h7-font-size-breakpoint-default: 0.875rem;
  --beacon-h7-font-size-breakpoint-medium: 1rem;
  --beacon-h7-font-size-breakpoint-large: 1rem;
  --beacon-h7-font-size-breakpoint-x-large: 1.125rem;
  --beacon-link-font-line-height-breakpoint-small: 16px;
  --beacon-link-font-line-height-breakpoint-large: calc(5 * 4px);
  --beacon-link-font-size-breakpoint-small: 0.875rem;
  --beacon-link-font-size-breakpoint-large: 1.125rem;
  --beacon-p-font-line-height-long-form-breakpoint-default: 1.56;
  --beacon-p-font-line-height-long-form-breakpoint-medium: 1.60;
  --beacon-p-font-line-height-long-form-breakpoint-large: 1.60;
  --beacon-p-font-line-height-long-form-breakpoint-x-large: 1.33;
  --beacon-p-font-line-height-module-breakpoint-default: 1.33;
  --beacon-p-font-line-height-module-breakpoint-medium: 1.40;
  --beacon-p-font-line-height-module-breakpoint-large: 1.40;
  --beacon-p-font-line-height-module-breakpoint-x-large: 1.33;
  --beacon-p-font-size-breakpoint-default: 1.125rem;
  --beacon-p-font-size-breakpoint-medium: 1.25rem;
  --beacon-p-font-size-breakpoint-large: 1.25rem;
  --beacon-p-font-size-breakpoint-x-large: 1.5rem;
  --beacon-form-field-caret-color: #05c3de;
  --beacon-form-field-color-background: #ffffff;
  --beacon-form-field-color-border-default: #bec3c8;
  --beacon-form-field-color-border-error: #dd3636;
  --beacon-form-field-color-text-default: #3b4b59;
  --beacon-form-field-color-text-disabled: #929ba3;
  --beacon-form-field-color-text-error: #dd3636;
  --beacon-form-field-size-border-radius: 4px;
  --beacon-form-field-size-height: 40px;
  --beacon-form-field-space-padding: calc(4px + 8px);
  --beacon-form-focus-wrapper-color-border-on-dark: #ffffff;
  --beacon-form-focus-wrapper-color-border-on-light: #086ea1;
  --beacon-form-focus-wrapper-space-margin-default: 0 -3px -3px -3px;
  --beacon-form-focus-wrapper-space-margin-focus: -1px -4px -4px -4px;
  --beacon-form-focus-wrapper-space-padding: 3px;
  --beacon-form-font-line-height-breakpoint-default: 1.43;
  --beacon-form-font-line-height-breakpoint-medium: 1.50;
  --beacon-form-font-line-height-breakpoint-large: 1.50;
  --beacon-form-font-line-height-breakpoint-x-large: 1.56;
  --beacon-form-font-size-breakpoint-default: 0.875rem;
  --beacon-form-font-size-breakpoint-medium: 1rem;
  --beacon-form-font-size-breakpoint-large: 1rem;
  --beacon-form-font-size-breakpoint-x-large: 1.125rem;
  --beacon-form-icon-space-padding: 40px;
  --beacon-form-icon-space-position-left: left calc(8px + 4px) top 50%;
  --beacon-form-icon-space-position-right: right calc(8px + 4px) top 50%;
  --beacon-form-label-color-cta-default: #086ea1;
  --beacon-form-label-color-cta-focus: #ffffff;
  --beacon-form-label-font-family: Nimbus Sans Novus Bold, Helvetica, Arial, sans-serif;
  --beacon-form-label-font-line-height-breakpoint-default: 1.50;
  --beacon-form-label-font-line-height-breakpoint-medium: 1.56;
  --beacon-form-label-font-line-height-breakpoint-large: 1.56;
  --beacon-form-label-font-line-height-breakpoint-x-large: 1.60;
  --beacon-form-label-font-size-breakpoint-default: 1rem;
  --beacon-form-label-font-size-breakpoint-medium: 1.125rem;
  --beacon-form-label-font-size-breakpoint-large: 1.125rem;
  --beacon-form-label-font-size-breakpoint-x-large: 1.25rem;
  --beacon-form-label-font-text-on-dark: #d3d7da;
  --beacon-form-label-font-text-on-light: #3b4b59;
  --beacon-grid-column-size-width-small: calc( ((100vw - (0rem*2)) - (calc(6 + 1) * 1rem)) / 6);
  --beacon-grid-column-size-width-medium: calc( ((100vw - (1rem*2)) - (calc(12 + 1) * 1rem)) / 12);
  --beacon-grid-column-size-width-large: calc( ((100vw - (2rem*2)) - (calc(12 + 1) * 1.5rem)) / 12);
  --beacon-grid-column-size-width-x-large: calc( ((100vw - (4rem*2)) - (calc(12 + 1) * 1.5rem)) / 12);
  --beacon-grid-column-total-small: 6;
  --beacon-grid-column-total-medium: 12;
  --beacon-grid-column-total-large: 12;
  --beacon-grid-column-total-x-large: 12;
  --beacon-grid-gutter-size-width-small: 1rem;
  --beacon-grid-gutter-size-width-medium: 1rem;
  --beacon-grid-gutter-size-width-large: 1.5rem;
  --beacon-grid-gutter-size-width-x-large: 1.5rem;
  --beacon-grid-gutter-total-small: calc(6 + 1);
  --beacon-grid-gutter-total-medium: calc(12 + 1);
  --beacon-grid-gutter-total-large: calc(12 + 1);
  --beacon-grid-gutter-total-x-large: calc(12 + 1);
  --beacon-grid-layout-space-margin-breakpoint-default: 0.5rem;
  --beacon-grid-layout-space-margin-breakpoint-medium: 1rem;
  --beacon-grid-layout-space-margin-breakpoint-large: 2rem;
  --beacon-grid-layout-space-margin-breakpoint-x-large: 4rem;
  --beacon-grid-space-margin-small: 0rem;
  --beacon-grid-space-margin-medium: 1rem;
  --beacon-grid-space-margin-large: 2rem;
  --beacon-grid-space-margin-x-large: 4rem;
  --beacon-scroll-bar-color-background: #d3d7da;
  --beacon-scroll-bar-size-border: 4px;
  --beacon-scroll-bar-size-border-radius: calc(0.875 * 16px);
  --beacon-scroll-bar-size-width: calc(0.875 * 16px);
  --beacon-unit-atomic: 8px;
  --beacon-unit-base: 16px;
  --beacon-unit-subatomic: 4px;
}
.beacon-radio-button-group{
  --beacon-radio-button-text-color: var(--beacon-radio-button-color-text-default-on-light);
  --beacon-radio-button-border-color: var(--beacon-border-width-small) solid var(--beacon-radio-button-color-border-default-on-light);
  --beacon-radio-button-check-color: var(--beacon-radio-button-check-mark-color-background-default-on-light);
  --beacon-radio-button-border-checked-color: var(--beacon-border-width-small) solid var(--beacon-radio-button-color-border-active-on-light);
  --beacon-radio-button-input-focus-label: var(--beacon-border-width-small) dotted var(--beacon-radio-button-color-border-focus-on-light);
  --beacon-radio-button-diabled-label-border-color: var(--beacon-border-width-small) solid var(--beacon-radio-button-color-border-disabled-on-light);
  --beacon-radio-button-disabled-checked-label-color: var(--beacon-radio-button-color-text-disabled-on-light);
  --beacon-radio-button-input-disabled-checked-background: var(--beacon-radio-button-check-mark-color-background-disabled-on-light);
}
:global(.beacon-on-dark) .beacon-radio-button-group{
  --beacon-radio-button-text-color: var(--beacon-radio-button-color-text-default-on-dark);
  --beacon-radio-button-border-color: var(--beacon-border-width-small) solid var(--beacon-radio-button-color-border-default-on-dark);
  --beacon-radio-button-check-color: var(--beacon-radio-button-check-mark-color-background-default-on-dark);
  --beacon-radio-button-border-checked-color: var(--beacon-border-width-small) solid var(--beacon-radio-button-color-border-active-on-dark);
  --beacon-radio-button-input-focus-label: var(--beacon-border-width-small) dotted var(--beacon-radio-button-color-border-focus-on-dark);
  --beacon-radio-button-diabled-label-border-color: var(--beacon-border-width-small) solid var(--beacon-radio-button-color-border-disabled-on-dark);
  --beacon-radio-button-disabled-checked-label-color: var(--beacon-radio-button-color-text-disabled-on-dark);
  --beacon-radio-button-input-disabled-checked-background: var(--beacon-radio-button-check-mark-color-background-disabled-on-dark);
}
.beacon-radio-button{
  display:flex;
  justify-content:flex-start;
  margin:var(--beacon-radio-button-space-margin-default)
}
.beacon-radio-button:first-child{
  margin:var(--beacon-radio-button-space-margin-first-child)
}
.beacon-radio-button:last-child{
  margin:var(--beacon-radio-button-space-margin-last-child)
}
.beacon-radio-button-title{
  font-family:var(--beacon-radio-button-title-font-family);
  font-size:var(--beacon-radio-button-title-font-size-breakpoint-default);
  line-height:var(--beacon-radio-button-title-font-line-height-breakpoint-default);
  margin:0;
  padding:0
}
.beacon-radio-button-hint-text{
  font-size:var(--beacon-radio-button-font-size-breakpoint-default);
  font-weight:var(--beacon-radio-button-hint-text-font-weight);
  line-height:var(--beacon-radio-button-font-line-height-breakpoint-default);
  margin:var(--beacon-radio-button-hint-text-space-margin);
  padding:0
}
.beacon-radio-button-title-wrapper .beacon-radio-button-title{
  color:var(--beacon-radio-button-text-color)
}
.beacon-radio-button-title-wrapper .beacon-radio-button-hint-text{
  color:var(--beacon-radio-button-text-color)
}
.beacon-radio-button-input+label .beacon-radio-button-label{
  font-size:var(--beacon-radio-button-font-size-breakpoint-default);
  line-height:var(--beacon-radio-button-font-line-height-breakpoint-default);
  padding:0
}
.beacon-radio-button .beacon-radio-button-input+label .beacon-radio-button-label{
  color:var(--beacon-radio-button-text-color)
}
.beacon-radio-button-input+label::before{
  background:var(--beacon-radio-button-label-color-background);
  border-radius:var(--beacon-radio-button-size-border-radius);
  box-sizing:border-box;
  content:"";
  display:inline-block;
  height:var(--beacon-radio-button-size-height-default);
  left:var(--beacon-radio-button-space-left-default);
  position:absolute;
  width:var(--beacon-radio-button-size-width-default)
}
.beacon-radio-button .beacon-radio-button-input+label::before{
  border:var(--beacon-radio-button-border-color);
}
.beacon-radio-button-input+label::after{
  border-radius:var(--beacon-radio-button-size-border-radius);
  box-sizing:border-box;
  content:"";
  display:inline-block;
  height:var(--beacon-radio-button-check-mark-size);
  left:var(--beacon-radio-button-check-mark-space-left);
  position:absolute;
  top:var(--beacon-radio-button-check-mark-space-top);
  width:var(--beacon-radio-button-check-mark-size)
}
.beacon-radio-button .beacon-radio-button-input:checked+label::after{
  background:var(--beacon-radio-button-check-color)
}
.beacon-radio-button .beacon-radio-button-input:checked+label::before{
  border:var(--beacon-radio-button-border-checked-color)
}
.beacon-radio-button-input+label .beacon-radio-button-label::after{
  box-sizing:border-box;
  content:"";
  display:inline-block;
  height:var(--beacon-radio-button-size-height-focus);
  left:var(--beacon-radio-button-space-left-default);
  position:absolute;
  top:var(--beacon-radio-button-space-top-default);
  visibility:visible;
  width:var(--beacon-radio-button-size-width-focus)
}
.beacon-radio-button-input:focus+label .beacon-radio-button-label::after{
  left:var(--beacon-radio-button-space-left-focus);
  top:var(--beacon-radio-button-space-top)
}
.beacon-radio-button .beacon-radio-button-input:focus+label .beacon-radio-button-label::after{
  border:var(--beacon-radio-button-input-focus-label)
}
.beacon-radio-button .beacon-radio-button-input:disabled+label::before{
  border:var(--beacon-radio-button-diabled-label-border-color);
}
.beacon-radio-button-input:checked+label .beacon-radio-button-label{
  font-family:var(--beacon-radio-button-label-font-family-active)
}
.beacon-radio-button .beacon-radio-button-input:disabled+label .beacon-radio-button-label{
  color:var(--beacon-radio-button-color-text-disabled-on-dark)
}
.beacon-radio-button .beacon-radio-button-input:disabled:checked+label .beacon-radio-button-label{
  color:var(--beacon-radio-button-disabled-checked-label-color)
}
.beacon-radio-button .beacon-radio-button-input:disabled:checked+label::after{
  background:var(--beacon-radio-button-input-disabled-checked-background)
}
:global(.beacon-on-dark) .beacon-radio-button .beacon-radio-button-input:disabled+label::before{
  background:var(--beacon-radio-button-color-background-disabled-on-dark);
  border:var(--beacon-radio-button-diabled-label-border-color)
}
.beacon-radio-button .beacon-radio-button-input:disabled:checked+label::before{
  border:var(--beacon-radio-button-diabled-label-border-color)
}
.beacon-radio-button-input{
  --beacon-radio-button-input-margin: 3px 3px 0px 5px;
  display:flex;
  opacity:0;
  margin: var(--beacon-radio-button-input-margin);
}
.beacon-radio-button-input+label{
  align-items:center;
  cursor:pointer;
  display:flex;
  height:var(--beacon-radio-button-size-height-default);
  position:relative
}
.beacon-radio-button-input:disabled+label{
  cursor:not-allowed
}
@media screen and (min-width: 640px){
  .beacon-radio-button-title{
      font-size:var(--beacon-radio-button-title-font-size-breakpoint-medium);
      line-height:var(--beacon-radio-button-title-font-line-height-breakpoint-medium)
  }
  .beacon-radio-button-hint-text{
      font-size:var(--beacon-radio-button-font-size-breakpoint-medium);
      line-height:var(--beacon-radio-button-font-line-height-breakpoint-medium)
  }
  .beacon-radio-button-input+label .beacon-radio-button-label{
      font-size:var(--beacon-radio-button-font-size-breakpoint-medium);
      line-height:var(--beacon-radio-button-font-line-height-breakpoint-medium)
  }
}
@media screen and (min-width: 960px){
  .beacon-radio-button-title{
      font-size:var(--beacon-radio-button-title-font-size-breakpoint-large);
      line-height:var(--beacon-radio-button-title-font-line-height-breakpoint-large)
  }
  .beacon-radio-button-hint-text{
      font-size:var(--beacon-radio-button-font-size-breakpoint-large);
      line-height:var(--beacon-radio-button-font-line-height-breakpoint-large)
  }
  .beacon-radio-button-input+label .beacon-radio-button-label{
      font-size:var(--beacon-radio-button-font-size-breakpoint-large);
      line-height:var(--beacon-radio-button-font-line-height-breakpoint-large)
  }
}
@media screen and (min-width: 1280px){
  .beacon-radio-button-title{
      font-size:var(--beacon-radio-button-title-font-size-breakpoint-x-large);
      line-height:var(--beacon-radio-button-title-font-line-height-breakpoint-x-large)
  }
  .beacon-radio-button-hint-text{
      font-size:var(--beacon-radio-button-font-size-breakpoint-x-large);
      line-height:var(--beacon-radio-button-font-line-height-breakpoint-x-large)
  }
  .beacon-radio-button-input+label .beacon-radio-button-label{
      font-size:var(--beacon-radio-button-font-size-breakpoint-x-large);
      line-height:var(--beacon-radio-button-font-line-height-breakpoint-x-large)
  }
}
`;

export default styles;